import { DataTable, PDFViewer, WrapperCard } from "~/Components";
import { Button, Col, Form, Grid, Input, message, Modal, Row, Select, Space, Spin, Typography } from "antd";
import styles from "../../../../Contract.module.scss";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { api, get } from "~/Services";
import { ContractDocument } from "~/Components/ContractDocuments/ContractDocuments";
import _, { find, isEmpty, map, upperFirst, values } from "lodash";
import * as yup from "yup";
import { ErrorMessage, Field, FieldProps, Formik } from "formik";
import TextArea from "antd/lib/input/TextArea";
import { useHasAccess } from "@hooks/useHasAccess";
import { getFormattedDate, hasKeyString, isReviewerApproved, monthChange, numberToWord } from "@utils/CommonUtils";
import { ApprovalModal } from "~/Components/ApprovalModal/approvalModal";
import { useAuth } from "@hooks/useAuth";
import { getColorizedReviewStatus, getColorizedValueDocuSign } from "@utils/getColorizedValue";
import { SuccessModal } from "@components/SuccessModal/SuccessModal";
import { useNotification } from "~/Hooks/useNotification";
import { useQuery } from "~/Hooks/useQuery";
import { EditOutlined } from "@ant-design/icons";
import Item from "antd/lib/descriptions/Item";
import { Icon } from "@iconify/react";
import { ResendModal } from "./Resend";
import { formatToDecimal } from "~/Utils";
import { v4 as uuidv4 } from "uuid";
import { spaFilterPaper, spaPaper } from "~/Utils/StringConstants";
import { useNavigate } from "react-router-dom";
import RichTextInput from "~/Components/TextEditor/textEditor";
import pdfMake from "pdfmake/build/pdfmake";
import { get as _get } from "lodash";
import { printPdf } from "~/Utils/pdfmake/generate-pdf";

const productList = [
  {
    productName: "Figma Pro",
    productType: "Licenses",
    unitPrice: "$12",
    quantity: "10",
    totalCost: "$120",
  },
  {
    productName: "Windows",
    productType: "Platform",
    unitPrice: "$14",
    quantity: "2",
    totalCost: "$28",
  },
];
const initialValue = {
  message: "",
  documentId: "",
};

export const ContractTable = ({
  documents,
  data,
  id,
  reviewers,
  detailsTrigger,
  fullEnvelopeDetails,
  notification,
  watchers,
  isMobile,
}: {
  documents: any;
  data: any;
  id: any;
  reviewers: any;
  detailsTrigger: (arg: any) => void;
  fullEnvelopeDetails: any;
  notification: any;
  watchers: any;
  isMobile: any;
}) => {
  const [selectedDocument, setSelectedDocument] = useState<string>("");
  const [loadingDocId, setLoadingDocId] = useState<string>("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modal, setModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [commentLoading, setCommentLoading] = useState(false);
  const [sendLoading, setSendLoading] = useState(false);
  const [url, setUrl] = useState("");
  const { hasRole } = useHasAccess();
  const [resend, setResend] = useState([]);
  const { openNotification } = useNotification();
  const [openApproveModal, setOpenApprovalModal] = useState(false);
  const [openCancelModal, setOpenCancellModal] = useState(false);
  const [openRejectModal, setOpenRejectModal] = useState(false);
  const [openSigningModal, setOpenSigningModal] = useState(false);
  const [openSendingModal, setOpenSendingModal] = useState(false);
  const [successOpen, setSuccessOpen] = useState(false);
  const [openResendModal, setOpenResendModal] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [openApproverModal, setOpenApproverModal] = useState(false);
  const [openWatcherModal, setOpenWatcherModal] = useState(false);
  const [openAirportModal, setOpenAirportModal] = useState(false);
  const [openAirportSectretariatModal, setOpenAirportSectretariatModal] = useState(false);
  const [openApcMemberModal, setOpenApcMemberModal] = useState(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const query = useQuery();
  const { user } = useAuth();
  const [editedDocuments, setEditedDocuments] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [hasErrors, setHasErrors] = useState(false);
  const [isModal, setIsModal] = useState<boolean>(false);
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [prevData, setPrevData] = useState<any[]>([]);
  const [approverList, setApproverList] = useState<any[]>([]);
  const [airportManagerList, setAirportMangerList] = useState<any[]>([]);
  const [loadingApproverList, setLoadingApproverList] = useState(false);
  const [loadingAirportList, setLoadingAirportList] = useState(false);
  const isMasterAdmin: any = user;
  const generateRandomUADId = () => Math.floor(Math.random() * 1000000000).toString();
  const versionKey = generateRandomUADId();
  const [pcdWatcherList, setPcdWatcherList] = useState<any[]>([]);
  const [loadingPcdList, setLoadingPcdList] = useState(false);

  const getPcdWatcherList = async () => {
    try {
      setLoadingPcdList(true);
      const response: any = await get(`/v1/spa/pcd-watcher/get-watcher-list?order=asc&size=20`);
      setPcdWatcherList(response?.response?.data?.records || []);
    } catch (error) {
      console.error("Failed to fetch PCD watcher list", error);
    } finally {
      setLoadingPcdList(false);
    }
  };

  useEffect(() => {
    if (openWatcherModal) {
      getPcdWatcherList();
    }
  }, [openWatcherModal]);
  useEffect(() => {
    if (data?.documentLinkDetails?.length > 0) {
      setPrevData(
        data.documentLinkDetails.map((doc: any) => ({
          id: uuidv4(),
          oldName: doc?.name ?? "",
          newName: doc?.name ?? "",
          oldUrl: doc?.url ?? "",
          newUrl: doc?.url ?? "",
        }))
      );
    }
  }, [data?.documentLinkDetails]);
  const pathName = location.pathname.split("/");
  const commenterRole = pathName.includes("spa-review");
  const [editData, setEditData] = useState<any[]>([]);
  const [deleteData, setDeleteData] = useState<any[]>([]);
  const [addData, setAddData] = useState<any[]>([]);
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();

  // const getPdfData = async (values: any) => {
  //   let logs = await get(`v1/auditlog/envelope/get-all-logs?envelopeId=${id}`);
  //   let docVersion = await get(`v1/spa/get/document/versions?envelopeId=${id}&order=desc&orderBy=updatedOn`);
  //   let comments = await get(`v1/workflow/getCommentsList?envelopeId=${id}&order=desc&orderBy=commentedOn`);
  //   return {
  //     ...data,
  //     ...values,
  //     reviewers,
  //     watchers,
  //     documents,
  //     logs: _get(logs, "response.data.records", []),
  //     docVersion: _get(docVersion, "response.data", []),
  //     comments: _get(comments, "response.data.records", []),
  //   };
  // };

  const getPdfData = async (values: any) => {
    reviewers?.forEach((r: any, i: number) => {
    });
    let logs = await get(`v1/auditlog/envelope/get-all-logs?envelopeId=${id}`);
    let docVersion = await get(`v1/spa/get/document/versions?envelopeId=${id}&order=desc&orderBy=updatedOn`);
    let comments = await get(`v1/workflow/getCommentsList?envelopeId=${id}&order=desc&orderBy=commentedOn`);
    const pdfPayload = {
      ...data,
      ...values,
      reviewers,
      watchers,
      documents,
      logs: _get(logs, "response.data.records", []),
      docVersion: _get(docVersion, "response.data", []),
      comments: _get(comments, "response.data.records", []),
    };
    pdfPayload.reviewers?.forEach((r: any, i: number) => {
    });
    return pdfPayload;
  };

  useEffect(() => {
    if (data && data.additionaldocument) {
      const transformedData = data.additionaldocument.map((url: any, index: any) => ({
        id: index,
        oldValue: url,
        newValue: url,
      }));
      setPrevData(transformedData);
    }
  }, [data]);

  const prepareAndSubmitDocuments = (values: any, formikHelpers: any) => {
    const updatedPrevData = [...prevData];

    // ADD & EDIT
    values.documentLinkDetails.forEach((doc: any) => {
      const existing = updatedPrevData.find((item: any) => item.id === doc.id);

      if (existing) {
        if (doc.name !== existing.oldName) {
          existing.newName = doc.name;
          setEditData((prev) => [...prev, { id: existing.id, name: doc.name }]);
        }

        if (doc.url !== existing.oldUrl) {
          existing.newUrl = doc.url;
          setEditData((prev) => [...prev, { id: existing.id, url: doc.url }]);
        }
      } else {
        const newDoc = {
          id: uuidv4(),
          oldName: "",
          newName: doc.name,
          oldUrl: "",
          newUrl: doc.url,
        };

        updatedPrevData.push(newDoc);
        setAddData((prev) => [...prev, { id: newDoc.id, name: doc.name, url: doc.url }]);
      }
    });

    // DELETE
    prevData.forEach((prevDoc: any) => {
      const deleted = !values.documentLinkDetails.some((doc: any) => doc.id === prevDoc.id);

      if (deleted) {
        setDeleteData((prev) => [...prev, { id: prevDoc.id }]);
      }
    });

    setPrevData(updatedPrevData);
    handleSubmitDocuments(values, formikHelpers, updatedPrevData);
  };

  const getApproverList = async () => {
    try {
      setLoadingApproverList(true);

      const approverListUrl = `/v1/spa/get-approver-list?authorityGroup=${data?.approvalAuthority}&subsidiary=${data?.subsidiary}&division=${encodeURIComponent(data?.division)}&budget=${encodeURIComponent(
        data?.budget
      )}`;

      const response: any = await get(approverListUrl);
      setApproverList(response?.response?.data || []);
    } catch (error) {
      console.error("Failed to fetch approver list", error);
    } finally {
      setLoadingApproverList(false);
    }
  };

  useEffect(() => {
    if (openApproverModal) {
      getApproverList();
    }
  }, [openApproverModal]);

  const getAirportManagerList = async () => {
    try {
      setLoadingAirportList(true);

      const approverListUrl = `/v1/spa/get-approver-list?authorityGroup=${data?.approvalAuthority}&subsidiary=${data?.subsidiary}&division=${data?.division}&budget=${encodeURIComponent(
        data?.budget
      )}`;

      const response: any = await get(approverListUrl);
      setAirportMangerList(response?.response?.data || []);
    } catch (error) {
      console.error("Failed to fetch approver list", error);
    } finally {
      setLoadingAirportList(false);
    }
  };

  useEffect(() => {
    if (openAirportModal || openAirportSectretariatModal || openApcMemberModal) {
      getAirportManagerList();
    }
  }, [openAirportModal, openAirportSectretariatModal, openApcMemberModal]);

  const getPdfBlobFromDocDefinition = (docDefinition: any): Promise<Blob> => {
    return new Promise((resolve, reject) => {
      try {
        pdfMake.createPdf(docDefinition).getBlob((blob: Blob) => {
          resolve(blob);
        });
      } catch (err) {
        reject(err);
      }
    });
  };

  const createPdfFile = (blob: Blob, fileName: string): File => {
    return new File([blob], fileName, {
      type: "application/pdf",
      lastModified: Date.now(),
    });
  };

  const isTotalCost = data?.currency?.totalCost;
  const handleCancel = () => {
    setIsModalVisible(false);
    setPrevData([]);
  };
  const userData: any = localStorage.getItem("user");
  const userDetails = JSON.parse(userData);
  const userEmail = userDetails.email;

  const handleEditToggleDocuments = () => {
    setIsModalVisible(true);
    setEditedDocuments(!editedDocuments);
  };
  const review = reviewers?.filter((item: any) => item.designation === "Airport Manager");
  const notApplicableReviewer = reviewers?.filter(
    (item: any) =>
      item.designation === "Manager" ||
      item.designation === "Senior Manager" ||
      item.designation === "APC Secretariat" ||
      item.designation === "APC SECRETARIAT"
  );
  const managerStatus = reviewers?.filter(
    (item: any) =>
      item.designation === "Manager" ||
      item.designation === "Senior Manager" ||
      item.designation === "APC Secretariat" ||
      item.designation === "APC SECRETARIAT" ||
      item.designation === "APC MEMBER" ||
      item.designation === "Executive" ||
      item.designation === "Senior Executive" ||
      item.designation === "Officer"
  );
  const isMangerNotApplicable = notApplicableReviewer?.some(
    (item: any) => item?.emailAddress === user?.email && item?.status === "Not Applicable"
  );
  const isManagerInProgress = managerStatus?.some(
    (item: any) => item?.emailAddress === user?.email && item?.status === "In-Progress"
  );

  const isHtmlString = (val: any) => typeof val === "string" && /<\/?[a-z][\s\S]*>/i.test(val);

  const getItemText = (name?: string, value?: any, className = "", isBoolean?: any, style = {}) => {
    if (value === "Invalid date") value = "-";
    return (
      <Space
        direction="vertical"
        style={{ marginBottom: styles.whitespace4, fontWeight: 100 }}
        className={className}
      >
        {isMobile ? <h4 style={{ color: "#29256E" }}>{name}</h4> : <h3 style={{ color: "#29256E" }}>{name}</h3>}
        <div style={{ color: "black" }}>
          {!isBoolean ? (
            Array.isArray(value) ? (
              value.map((link, index) => (
                <Typography.Text
                  key={index}
                  type="secondary"
                  style={{ display: "block" }}
                >
                  {link}
                </Typography.Text>
              ))
            ) : isHtmlString(value) ? (
              <div
                className="ck-content"
                style={{ fontWeight: "normal" }}
                dangerouslySetInnerHTML={{ __html: value }}
              />
            ) : (
              <Typography.Text>{value}</Typography.Text>
            )
          ) : value === "true" ? (
            <Typography.Text type="secondary">Enabled</Typography.Text>
          ) : (
            <Typography.Text type="secondary">Disabled</Typography.Text>
          )}
        </div>
      </Space>
    );
  };

  useEffect(() => {
    if (isMangerNotApplicable) {
      setIsModal(true);
    }
  }, [isMangerNotApplicable]);

  const status = () => {
    switch (data.status) {
      case "sent":
        return true;
      case "In-Progress":
        return true;
      case "created":
        return true;
      default:
        return false;
    }
  };

  const getColor = (value: string) => {
    return getColorizedReviewStatus(value);
  };

  const sentColor = (value: string) => {
    if (value == "created") {
      return (
        <Typography.Text
          style={{
            backgroundColor: "#FFF5E9",
            padding: "6px 19px",
            borderRadius: 9,
            color: "#FF981F",
          }}
        >
          {value}
        </Typography.Text>
      );
    } else if (value == "sent") {
      return (
        <Typography.Text
          style={{
            backgroundColor: "#FFF5E9",
            padding: "6px 19px",
            borderRadius: 9,
            color: "#FF981F",
          }}
        >
          {value}
        </Typography.Text>
      );
    } else {
      return (
        <Typography.Text
          style={{
            backgroundColor: "#E5F9ED",
            padding: "6px 19px",
            borderRadius: 9,
            color: "#00C247",
          }}
        >
          {value}
        </Typography.Text>
      );
    }
  };

  const budgetManagers =
    reviewers &&
    reviewers.filter(
      (reviewer: any) =>
        reviewer.designation === "Senior Manager" ||
        reviewer.designation === "Manager" ||
        reviewer.designation === "APC Secretariat" ||
        reviewer.designation === "Senior Executive" ||
        reviewer.designation === "Officer" ||
        reviewer.designation === "Executive"
    );
  // const approvers =
  //   reviewers &&
  //   reviewers.filter(
  //     (reviewer: any) =>
  //       reviewer.designation !== "Manager" &&
  //       reviewer.designation !== "One Stop Centre" &&
  //       reviewer.designation !== "One Stop Centre, PCD" &&
  //       reviewer?.designation !== "Secretariat, PCD" &&
  //       reviewer?.designation !== "Secratariat, PCD" &&
  //       reviewer.designation !== "Senior Manager" &&
  //       reviewer.designation !== "APC Secretariat"
  //   );

  const approvers =
    reviewers &&
    reviewers
      .filter(
        (reviewer: any) =>
          reviewer.designation !== "Manager" &&
          reviewer.designation !== "One Stop Centre" &&
          reviewer.designation !== "One Stop Centre, PCD" &&
          reviewer?.designation !== "Secretariat, PCD" &&
          reviewer?.designation !== "Secratariat, PCD" &&
          reviewer.designation !== "Senior Manager" &&
          reviewer.designation !== "APC Secretariat"
      )
      .sort((a: any, b: any) => {
        if (data?.approvalAuthority === "HeadofSubsidiary" || data?.approvalAuthority === "Head of Subsidiary") {
          const getOrder = (designation: string) => {
            if (designation === "R1") return 1;
            if (designation === "R2") return 2;
            if (designation === "Head of Subsidiary") return 3;
            return 99;
          };
          const aOrder = getOrder(a.designation);
          const bOrder = getOrder(b.designation);

          if (aOrder !== 99 || bOrder !== 99) {
            return aOrder - bOrder;
          }
        }
        const aRoutingOrder =
          a.routingOrder ?? a.sequenceOrder ?? a.order ?? a.reviewerOrder ?? a.sortOrder ?? a.reviewingOrder ?? 99;
        const bRoutingOrder =
          b.routingOrder ?? b.sequenceOrder ?? b.order ?? b.reviewerOrder ?? b.sortOrder ?? b.reviewingOrder ?? 99;

        if (aRoutingOrder !== bRoutingOrder) {
          return aRoutingOrder - bRoutingOrder;
        }

        return 0;
      });
  reviewers?.forEach((r: any, i: number) => {
  });
  approvers?.forEach((r: any, i: number) => {
  });

  const airportAPC = reviewers && reviewers.filter((reviewer: any) => reviewer.designation === "APC SECRETARIAT");

  const airportAPCMember = reviewers && reviewers.filter((reviewer: any) => reviewer.designation === "APC MEMBER");

  const airportManager = reviewers && reviewers.filter((reviewer: any) => reviewer.designation === "Airport Manager");

  const oneStopCentre =
    reviewers &&
    reviewers.filter(
      (reviewer: any) =>
        reviewer?.designation === "One Stop Centre" ||
        reviewer?.designation === "One Stop Centre, PCD" ||
        reviewer?.designation === "Secretariat, PCD" ||
        reviewer?.designation === "Secratariat, PCD"
    );
  // 🔍 CRITICAL: Check for reviewers that fall into MULTIPLE groups or NO group (these cause ordering bugs)
  const allGrouped = [
    ...(budgetManagers || []),
    ...(oneStopCentre || []),
    ...(airportAPC || []),
    ...(airportAPCMember || []),
    ...(airportManager || []),
    ...(approvers || []),
  ];
  const ungrouped = reviewers?.filter((r: any) => !allGrouped.some((g: any) => g.id === r.id)) || [];
  const duplicated = reviewers?.filter((r: any) => allGrouped.filter((g: any) => g.id === r.id).length > 1) || [];

  let sortedWatchers =
    watchers &&
    watchers?.sort((a: any, b: any) => {
      if (a.role === "R1" && b.role !== "R1") {
        return -1;
      } else if (a.role !== "R1" && b.role === "R1") {
        return 1;
      } else {
        return 0;
      }
    });

  sortedWatchers = sortedWatchers && sortedWatchers.filter((item: any) => !isEmpty(item.emailAddress));
  const onResend = () => {
    setOpenResendModal(true);
  };

  const validationSchema = yup.object().shape({
    projectTitle: yup.string().required("Project Name is required"),
    budget: yup.string().required("Budget is required"),
    awardAndStrategyPaper: yup.string().required("SPA type is required"),
    projectSummary: yup.string().required("Project summary is required"),
    procurementNumber: yup.string().required("Procurement number is required"),
    procurementSummary: yup.string().required("Procurement summary is required"),
    recommendedVendor: yup.string().required("Recommended vendor is required"),
    contractValue: yup.string().required("Contract value is required"),
    contractPeriod: yup.string().required("Contract period is required").nullable(),
  });

  const validationSchema2 = yup.object().shape({
    documentLinkDetails: yup.array().of(
      yup.object().shape({
        name: yup
          .string()
          .nullable()
          .transform((value) => (value?.trim() === "" ? null : value))
          .required("Document name is required"),
        url: yup
          .string()
          .nullable()
          .typeError("File URL must start with https://")
          .transform((value) => (value?.trim() === "" ? null : value))
          .matches(/^https:\/\//, "File URL must start with https://"),
      })
    ),
  });
  const commentsValidationSchema = yup.object().shape({
    message: yup.string().required("Comment is required"),
  });

  const watcherValidationSchema = yup.object().shape({
    watchers: yup.array().of(
      yup.object().shape({
        name: yup.string().trim().required("Name is required"),

        emailAddress: yup.string().trim().email("Invalid email format").required("Email is required"),

        role: yup.string().trim().required("Role is required"),
      })
    ),
  });

  const airportAPCValidationSchema = yup.object().shape({
    airportAPC: yup.array().of(
      yup.object().shape({
        name: yup.string().trim().required("Name is required"),

        emailAddress: yup.string().trim().email("Invalid email format").required("Email is required"),

        designation: yup.string().trim().required("Role is required"),
      })
    ),
  });

  const airportAPCMemberValidationSchema = yup.object().shape({
    airportAPCMember: yup.array().of(
      yup.object().shape({
        name: yup.string().trim().required("Name is required"),

        emailAddress: yup.string().trim().email("Invalid email format").required("Email is required"),

        designation: yup.string().trim().required("Role is required"),
      })
    ),
  });

  const handlePlaceHolder = (value: any) => {
    setOpenSigningModal(value);
    setLoading(value);
  };

  const handleSendSigning = (value: any) => {
    setOpenApprovalModal(value);
    setSendLoading(value);
  };

  const onCancelModal = (value: any) => {
    setOpenCancellModal(value);
    setSendLoading(value);
  };

  const handleSendReject = (value: any) => {
    setOpenRejectModal(value);
    setSendLoading(value);
  };

  const onCancel = () => {
    setOpenResendModal(false);
  };

  const handleSend = (value: any) => {
    setOpenSendingModal(value);
    setSendLoading(value);
  };

  const handleTrigger = (value: any) => {
    detailsTrigger(value);
  };

  const updatedValue = (value: any) => {
    detailsTrigger(value);
  };

  const handleEditToggle = () => {
    setEditMode(!editMode);
  };

  const handleEditApproversToggle = () => {
    setOpenApproverModal(true);
  };

  const handleEditWatchersToggle = () => {
    setOpenWatcherModal(true);
  };

  const handleEditAirportToggle = () => {
    setOpenAirportModal(true);
  };

  const handleEditAirportSectretariatToggle = () => {
    setOpenAirportSectretariatModal(true);
  };

  const handleAirportSectretariatCancel = () => {
    setOpenAirportSectretariatModal(false);
  };

  const handleEditApcMemberToggle = () => {
    setOpenApcMemberModal(true);
  };

  const handleApcMemberCancel = () => {
    setOpenApcMemberModal(false);
  };

  const handleApproverCancel = () => {
    setOpenApproverModal(false);
  };

  const handleWatcherCancel = () => {
    setOpenWatcherModal(false);
  };

  const handleAirportCancel = () => {
    setOpenAirportModal(false);
  };

  const handleApproversEditSubmit = async (values: any) => {
    const isWatcherFlow = !!values?.watchers;
    const isApproverFlow = !!values?.approvers || !!values?.airportAPC || !!values?.airportAPCMember;
    try {
      setIsLoading(true);

      const nextVersionOrder = Number(data?.lastVersion ?? 0) + 1;

      let editedItems: any[] = [];
      let payload: any[] = [];
      let urlUpdate = "";

      if (isApproverFlow) {
        const allApprovers = [
          ...(values?.approvers || []),
          ...(values?.airportAPC || []),
          ...(values?.airportAPCMember || []),
        ];

        const originalApprovers = [...(approvers || []), ...(airportAPC || []), ...(airportAPCMember || [])];

        editedItems = allApprovers.filter((approver: any) => {
          const original = originalApprovers.find((orig: any) => orig.id === approver.id);

          if (!original) return true;

          return (
            approver?.name !== original?.name ||
            approver?.emailAddress !== original?.emailAddress ||
            approver?.designation !== original?.designation
          );
        });

        payload = editedItems.map((approver: any) => ({
          id: approver.id,
          envelopeId: id,
          reviewerName: approver.name,
          email: approver.emailAddress,
          designation: approver.designation,
          division: data?.division,
          subsidiary: data?.subsidiary,
          authorityGroup: data?.approvalAuthority,
          budget: data?.budget,
        }));

        urlUpdate = `v1/workflow/edit-spa-reviewer`;
      }

      if (isWatcherFlow) {
        editedItems = values?.watchers.filter((watcher: any) => {
          const original = watchers.find((orig: any) => orig.id === watcher.id);

          if (!original) return true;

          return (
            watcher?.name !== original?.name ||
            watcher?.emailAddress !== original?.emailAddress ||
            watcher?.role !== original?.role
          );
        });

        payload = editedItems.map((watcher: any) => ({
          id: watcher.id,
          reviewerName: watcher.name,
          email: watcher.emailAddress,
          envelopeId: id,
        }));

        urlUpdate = `v1/workflow/edit-spa-watcher`;
      }

      const documentDataFields =
        data?.documentVersionResponses?.map((item: any) => ({
          id: item.documentId,
          name: item?.documentName,
        })) || [];

      const overallPdfRegex = new RegExp(`^SPA${data?.projectId}\\(V\\d+\\)\\.pdf$`);

      const existingOverallDoc = documentDataFields.find((doc: any) => overallPdfRegex.test(doc.name));

      const deleteIds = existingOverallDoc ? [existingOverallDoc.id] : [];

      const deleteFormData = new FormData();

      const remainingDocs = documentDataFields.filter((doc: any) => !deleteIds.includes(doc.id));

      deleteFormData.append("existing_id", remainingDocs.map((d: any) => d.id).join(","));

      deleteFormData.append(
        "existing_file_names",
        remainingDocs.map((d: any) => encodeURIComponent(d.name))
      );

      deleteFormData.append("versionOrder", `${nextVersionOrder}`);
      deleteFormData.append("versionKey", versionKey);
      deleteFormData.append("envelopeId", id);
      deleteFormData.append("delete_id", deleteIds.join(","));

      const urlLock = `v1/workflow/document-lock?envelopeId=${id}&versionOrder=${nextVersionOrder}&versionKey=${versionKey}`;
      const urlDelete = `v1/spa/delete/spaDocument`;
      const urlUpdateDoc = `v1/spa/update/spaDocument`;
      const urlTriggerMail = `v1/spa/trigger/document-version-mail?envelopeId=${id}&versionOrder=${nextVersionOrder}`;

      await api.put(urlLock);
      await api.post(urlDelete, deleteFormData);

      const createDocumentFormData = await createPdfFormData(values);
      await api.put(urlUpdateDoc, createDocumentFormData);

      await api.put(urlTriggerMail);

      await api.put(urlUpdate, payload);

      setOpenApproverModal(true);
      detailsTrigger(data);

      openNotification({
        title: "Success",
        message: isWatcherFlow ? "Watchers updated successfully" : "Approvers updated successfully",
        type: "success",
      });
    } catch (err) {
      console.error(err);
      openNotification({
        title: "Error",
        message: "Failed to update details",
        type: "error",
      });
    } finally {
      setIsLoading(false);
    }
  };

  // const createPdfFormData = async (values: any) => {
  //   const nextVersionOrder = Number(data?.lastVersion ?? 0) + 1;

  //   let randomCreateId = parseInt(`1${data?.lastVersion + 1}0`, 10);
  //   randomCreateId += 2;

  //   const pdfData = await getPdfData(values);

  //   const docDefinition = printPdf(pdfData, "view");

  //   const pdfBlob = await getPdfBlobFromDocDefinition(docDefinition);

  //   const pdfFile = createPdfFile(pdfBlob, `SPA${data?.projectId}(V${nextVersionOrder}).pdf`);

  //   const formData = new FormData();
  //   formData.append("create_id", `${randomCreateId}`);
  //   formData.append("versionOrder", `${nextVersionOrder}`);
  //   formData.append("versionKey", versionKey);
  //   formData.append("envelopeId", id);
  //   formData.append("create-document-file", pdfFile);

  //   return formData;
  // };

  const createPdfFormData = async (values: any) => {
    const nextVersionOrder = Number(data?.lastVersion ?? 0) + 1;

    let randomCreateId = parseInt(`1${data?.lastVersion + 1}0`, 10);
    randomCreateId += 2;
    const pdfData = await getPdfData(values);
    pdfData.reviewers?.forEach((r: any, i: number) => {
    });

    const docDefinition = printPdf(pdfData, "view");

    const pdfBlob = await getPdfBlobFromDocDefinition(docDefinition);

    const pdfFileName = `SPA${data?.projectId}(V${nextVersionOrder}).pdf`;
    const pdfFile = createPdfFile(pdfBlob, pdfFileName);

    const formData = new FormData();
    formData.append("create_id", `${randomCreateId}`);
    formData.append("versionOrder", `${nextVersionOrder}`);
    formData.append("versionKey", versionKey);
    formData.append("envelopeId", id);
    formData.append("create-document-file", pdfFile);

    formData.forEach((value, key) => {
    });
    return formData;
  };

  const handleSave = async (values: any) => {
    try {
      setIsLoading(true);
      const nextVersionOrder = Number(data?.lastVersion ?? 0) + 1;

      const documentDataFields =
        data?.documentVersionResponses?.map((item: any) => ({
          id: item.documentId,
          name: item?.documentName,
        })) || [];

      const overallPdfRegex = new RegExp(`^SPA${data?.projectId}\\(V\\d+\\)\\.pdf$`);

      const existingOverallDoc = documentDataFields.find((doc: any) => overallPdfRegex.test(doc.name));

      const deleteIds = existingOverallDoc ? [existingOverallDoc.id] : [];

      const deleteFormData = new FormData();

      const remainingDocs = documentDataFields.filter((doc: any) => !deleteIds.includes(doc.id));

      deleteFormData.append("existing_id", remainingDocs.map((d: any) => d.id).join(","));

      deleteFormData.append(
        "existing_file_names",
        remainingDocs.map((d: any) => encodeURIComponent(d.name))
      );

      deleteFormData.append("versionOrder", `${nextVersionOrder}`);
      deleteFormData.append("versionKey", versionKey);
      deleteFormData.append("envelopeId", id);
      deleteFormData.append("delete_id", deleteIds.join(","));
      const payload = {
        projectTitle: values.projectTitle,
        projectSummary: values.projectSummary,
        procurementNumber: values.procurementNumber,
        procurementSummary: values.procurementSummary,
        recommendedVendor: values.recommendedVendor,
        contractValue: values.contractValue,
        contractPeriod: values.contractPeriod,
        budget: values.budget,
        awardAndStrategyPaper: values.awardAndStrategyPaper,
      };

      const formData = new FormData();
      formData.append("body", JSON.stringify(payload));
      formData.append("envelopeId", id);

      const url1 = `v1/spa/spa-edit-document`;
      const url2 = `v1/workflow/document-lock?envelopeId=${id}&versionOrder=${nextVersionOrder}&versionKey=${versionKey}`;
      const url3 = `v1/spa/delete/spaDocument`;
      const url4 = `v1/spa/update/spaDocument`;
      const url5 = `v1/spa/trigger/document-version-mail?envelopeId=${id}&versionOrder=${nextVersionOrder}`;
      await api.put(url1, formData);
      await api.put(url2);
      await api.post(url3, deleteFormData);
      const createDocumentFormData = await createPdfFormData(values);
      await api.put(url4, createDocumentFormData);

      await api.put(url5);

      updatedValue(yup.boolean);
      setEditMode(false);

      openNotification({
        title: "Success",
        message: "Project details updated successfully",
        type: "success",
      });
    } catch (err) {
      console.error(err);
      openNotification({
        title: "Error",
        message: "Failed to update project details",
        type: "error",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmit = (values: any, { setSubmitting }: any) => {};

  const onCancelEdit = () => {
    setEditMode(false);
  };

  const onCancelDocEdit = () => {
    setEditedDocuments(false);
  };

  const processMessageWithUrls = (message: any) => {
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    if (urlRegex.test(message)) {
      urlRegex.lastIndex = 0;
      return message.replace(urlRegex, (url: any) => {
        return `<a href="${url}" target="_blank">${url}</a>`;
      });
    }
    return message;
  };

  const handleSubmitDocuments = async (values: any, { setSubmitting }: any, updatedPrevData: any) => {
    try {
      setIsLoading(true);

      const nextVersionOrder = Number(data?.lastVersion ?? 0) + 1;

      const overallPdfRegex = new RegExp(`^SPA${data?.projectId}\\(V\\d+\\)\\.pdf$`);

      const existingDocs =
        data?.documentVersionResponses?.map((item: any) => ({
          id: item.documentId,
          name: item?.documentName,
        })) || [];
      const existingOverallDoc = existingDocs.find((doc: any) => overallPdfRegex.test(doc.name));
      const deleteIds = existingOverallDoc ? [existingOverallDoc.id] : [];

      const deleteFormData = new FormData();

      const remainingDocs = existingDocs.filter((doc: any) => !deleteIds.includes(doc.id));

      deleteFormData.append("existing_id", remainingDocs.map((d: any) => d.id).join(","));

      deleteFormData.append(
        "existing_file_names",
        remainingDocs.map((d: any) => encodeURIComponent(d.name))
      );

      deleteFormData.append("versionOrder", `${nextVersionOrder}`);
      deleteFormData.append("versionKey", versionKey);
      deleteFormData.append("envelopeId", id);
      deleteFormData.append("delete_id", deleteIds.join(","));

      const urlLock = `v1/workflow/document-lock?envelopeId=${id}&versionOrder=${nextVersionOrder}&versionKey=${versionKey}`;
      const urlDelete = `v1/spa/delete/spaDocument`;
      const urlUpdateDoc = `v1/spa/update/spaDocument`;
      const urlTriggerMail = `v1/spa/trigger/document-version-mail?envelopeId=${id}&versionOrder=${nextVersionOrder}`;
      const urlUpdateLinks = `v1/spa/update/document-links?envelopeId=${id}`;

      await api.put(urlLock);

      await api.post(urlDelete, deleteFormData);

      const createDocumentFormData = await createPdfFormData(values);
      await api.put(urlUpdateDoc, createDocumentFormData);

      await api.put(urlTriggerMail);

      const added: string[] = [];
      const edited: string[] = [];
      const deleted: string[] = [];

      updatedPrevData.forEach((item: any) => {
        const stillExists = values.documentLinkDetails.some((doc: any) => doc.id === item.id);

        if (!stillExists && item.oldUrl) {
          deleted.push(encodeURIComponent(item.oldUrl));
        } else if (!item.oldUrl && item.newUrl) {
          added.push(encodeURIComponent(item.newUrl));
        } else if (item.oldUrl !== item.newUrl) {
          edited.push(encodeURIComponent(item.newUrl));
        }
      });

      const linkPayload = {
        documentLinksDetails: values.documentLinkDetails.map((doc: any) => ({
          name: doc.name,
          url: encodeURIComponent(doc.url),
        })),
        addedLinks: added,
        editedLinks: edited,
        deletedLinks: deleted,
      };

      await api.put(urlUpdateLinks, linkPayload);

      updatedValue(yup.boolean);
      setEditedDocuments(false);
      setSubmitting(false);
      detailsTrigger(data);

      openNotification({
        title: "Success",
        message: "Documents updated successfully",
        type: "success",
      });
    } catch (err) {
      console.error(err);

      setSubmitting(false);
      setEditedDocuments(false);

      openNotification({
        title: "Error",
        message: "Failed to update documents",
        type: "error",
      });
    } finally {
      setIsLoading(false);
    }
  };
  const pcdDetail = (watchers ?? []).find((watcher: any) => watcher.role === "PCD");
  return (
    <>
      <WrapperCard
        isMobile={isMobile}
        action={
          <>
            {((!editMode && data.status !== "completed" && hasKeyString("review") && data.status === "draft") ||
              (hasKeyString("watcher") && data.status !== "draft") ||
              (!hasKeyString("review") && data.status !== "draft" && data.status !== "completed")) && (
              <Icon
                icon="carbon:edit"
                inline
                className="doc-icon"
                fontSize={24}
                style={{
                  marginLeft: 8,
                  marginRight: 8,
                }}
                cursor="pointer"
                onClick={handleEditToggle}
              />
            )}
          </>
        }
        title={"Project Information"}
        bodyClass="h-inherit"
        smallHeader
      >
        <Row gutter={[16, 16]}>
          {selectedDocument && (
            <PDFViewer
              show={true}
              title={"View Document"}
              subTitle={""}
              setShow={() => setSelectedDocument("")}
              url={selectedDocument}
            />
          )}
          <Col
            xs={!editMode ? 24 : ""}
            md={!editMode ? 8 : ""}
          >
            {editMode ? (
              <Formik
                enableReinitialize
                initialValues={{
                  projectTitle: data.projectTitle,
                  projectSummary: data.projectSummary,
                  procurementNumber: data.procurementNumber,
                  procurementSummary: data.procurementSummary,
                  recommendedVendor: data.recommendedVendor,
                  contractValue: data.contractValue,
                  contractPeriod: data.contractPeriod,
                  budget: data.budget,
                  awardAndStrategyPaper: data.awardAndStrategyPaper,
                }}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
              >
                {({ handleChange, handleSubmit, values, errors, touched, setFieldValue }) => {
                  const isEditorEmpty = (html: string) => html.replace(/<(.|\n)*?>/g, "").trim().length === 0;
                  return (
                    <Form
                      layout="vertical"
                      onFinish={handleSubmit}
                    >
                      <Row gutter={16}>
                        <Col span={24}>
                          <Form.Item label="Project ID">
                            <Input
                              disabled
                              defaultValue={data.projectId}
                            />
                          </Form.Item>
                        </Col>
                        <Col span={24}>
                          <Form.Item
                            label="Project Name"
                            name="projectTitle"
                          >
                            <TextArea
                              showCount
                              maxLength={5000}
                              value={values.projectTitle}
                              defaultValue={data.projectTitle}
                              onChange={handleChange("projectTitle")}
                            />
                            <Typography.Text type="danger">
                              <ErrorMessage
                                name="projectTitle"
                                component="div"
                                className="field-error"
                              />
                            </Typography.Text>
                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Form.Item
                            label="Budget"
                            name="budget"
                          >
                            <Input
                              readOnly
                              defaultValue={(data.budget && data.budget) || "Uncategorized"}
                            />
                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Form.Item
                            label="SPA Types"
                            name="awardAndStrategyPaper"
                          >
                            <Select
                              defaultValue={data.awardAndStrategyPaper}
                              onChange={(e) => {
                                setFieldValue("awardAndStrategyPaper", e);
                              }}
                            >
                              {spaPaper &&
                                spaPaper.map((item, index) => {
                                  return (
                                    <Select.Option
                                      value={item}
                                      key={index}
                                    >
                                      {item}
                                    </Select.Option>
                                  );
                                })}
                            </Select>
                            <Typography.Text type="danger">
                              <ErrorMessage
                                name="awardAndStrategyPaper"
                                component="div"
                                className="field-error"
                              />
                            </Typography.Text>
                          </Form.Item>
                        </Col>
                        <Col span={24}>
                          <Form.Item
                            label="Project Summary"
                            name="projectSummary"
                          >
                            <TextArea
                              showCount
                              maxLength={50000}
                              value={values.projectSummary}
                              defaultValue={data.projectSummary}
                              onChange={handleChange("projectSummary")}
                            />
                            <Typography.Text type="danger">
                              <ErrorMessage
                                name="projectSummary"
                                component="div"
                                className="field-error"
                              />
                            </Typography.Text>
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row gutter={16}>
                        <Col span={24}>
                          <Form.Item
                            label={
                              <>
                                <h3>B. Summary of the Procurement (e.g Background, Evaluation & Justification)</h3>
                              </>
                            }
                            name="procurementSummary"
                          >
                            <div style={{ overflowX: "auto" }}>
                              <RichTextInput
                                showCount
                                maxLength={50000}
                                value={values.procurementSummary}
                                onChange={(val) => {
                                  (handleChange("procurementSummary"),
                                    setFieldValue("procurementSummary", isEditorEmpty(val) ? "" : val));
                                }}
                              />
                            </div>
                            <Typography.Text type="danger">
                              <ErrorMessage
                                name="procurementSummary"
                                component="div"
                                className="field-error"
                              />
                            </Typography.Text>
                          </Form.Item>
                        </Col>
                        <Col span={24}>
                          <Form.Item
                            label={
                              <>
                                <div>
                                  {isMobile ? <h4>C.Recommendation</h4> : <h3>C.Recommendation</h3>}
                                  <div>Recommended Bidder/Vendor</div>
                                </div>
                              </>
                            }
                            name="recommendedVendor"
                          >
                            <TextArea
                              showCount
                              maxLength={50000}
                              value={values.recommendedVendor}
                              defaultValue={data.recommendedVendor}
                              onChange={handleChange("recommendedVendor")}
                            />
                            <Typography.Text type="danger">
                              <ErrorMessage
                                name="recommendedVendor"
                                component="div"
                                className="field-error"
                              />
                            </Typography.Text>
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row gutter={16}>
                        <Col span={24}>
                          <Form.Item
                            label="Proposed Contract Value"
                            name="contractValue"
                          >
                            <TextArea
                              showCount
                              maxLength={5000}
                              value={values.contractValue}
                              defaultValue={data.contractValue}
                              onChange={handleChange("contractValue")}
                            />
                            <Typography.Text type="danger">
                              <ErrorMessage
                                name="contractValue"
                                component="div"
                                className="field-error"
                              />
                            </Typography.Text>
                          </Form.Item>
                        </Col>
                        <Col span={24}>
                          <Form.Item
                            label="Proposed Contract Period"
                            name="contractPeriod"
                          >
                            <TextArea
                              showCount
                              maxLength={5000}
                              value={values.contractPeriod}
                              defaultValue={data.contractPeriod}
                              onChange={handleChange("contractPeriod")}
                            />
                            <Typography.Text type="danger">
                              <ErrorMessage
                                name="contractPeriod"
                                component="div"
                                className="field-error"
                              />
                            </Typography.Text>
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row gutter={16}>
                        <Col span={12}>
                          <Form.Item
                            label="Budget Amount/Pre-Tender Estimate (PTE)"
                            name="totalCost"
                          >
                            <Input
                              disabled={true}
                              defaultValue={formatToDecimal(data?.currency?.totalCost, data?.currency?.currencyCode)}
                              onChange={handleChange("contractValue")}
                            />
                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Form.Item
                            label="Subsidiary/Division"
                            name="subsidiary"
                          >
                            <Input
                              disabled={true}
                              defaultValue={data.subsidiary}
                              onChange={handleChange("contractPeriod")}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row gutter={16}>
                        <Col span={12}>
                          <Form.Item
                            label="Cost Centre"
                            name="division"
                          >
                            <Input
                              disabled={true}
                              defaultValue={data.division}
                              onChange={handleChange("contractValue")}
                            />
                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Form.Item
                            label="Status"
                            name="status"
                          >
                            <Input
                              disabled={true}
                              defaultValue={upperFirst(data.status)}
                              onChange={handleChange("contractPeriod")}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row>
                        {editMode && (
                          <Row gutter={[16, 16]}>
                            <div style={{ width: "100%" }}>
                              <h3>A. Information on Procurement Process</h3>
                              {data.procurementNumber === "1a" && (
                                <div style={{ marginBottom: "30px" }}>
                                  1a. Direct Appointment (Based on Permissible Criteria) - OEM/Sole – The procurement of
                                  services, goods or works through OEM, sole Agency proprietorship, sole distributorship
                                  and the likes.
                                </div>
                              )}
                              {data.procurementNumber === "1b" && (
                                <div style={{ marginBottom: "30px" }}>
                                  1b. Direct Appointment (Based on Permissible Criteria) - Wholly Owned
                                  Subsidiaries/Inter Companies – The procurement of works, services and supplies from
                                  wholly owned subsidiaries/intercompanies.
                                </div>
                              )}
                              {data.procurementNumber === "1c" && (
                                <div style={{ marginBottom: "30px" }}>
                                  1c. Direct Appointment (Based on Permissible Criteria) - Government Sanctioned Rate –
                                  The Procurement of services from any Government Agencies or any Government sanctioned
                                  bodies which is unavoidable for purpose of certification or anything that is relevant
                                  to ensure business continuity of the organization
                                </div>
                              )}

                              {data.procurementNumber === "1d" && (
                                <div style={{ marginBottom: "30px" }}>
                                  1d. Direct Appointment (Based on Permissible Criteria) - Emergency cases on Operation
                                  Critical nature- The procurement of services and goods in emergency cases.
                                  Specifically, the term ‘Emergency’ shall be confined to a situation where immediate,
                                  in-situ and impromptu attention and execution are a mission critical in the even that
                                  a slight delay will may discontinue or may severely disrupt the operational functions
                                  of the business entity, in general and the airport, in particular.
                                </div>
                              )}
                              {data.procurementNumber === "1e" && (
                                <div style={{ marginBottom: "30px" }}>
                                  1e. Direct Appointment (Based on Permissible Criteria) - Specialist Consultancy
                                  Services - These services involve providing specific, unique and strategic expertise
                                  tailored to meet the specialized needs including but not limited to procurement
                                  solutions, legal advice, human resources, tax consultancy, and similar fields. The
                                  focus is on delivering expert support that caters to the complexities of niche
                                  sectors.
                                </div>
                              )}
                              {data.procurementNumber === "1f" && (
                                <div style={{ marginBottom: "30px" }}>
                                  1f. Direct Appointment (Based on Permissible Criteria) - Continuation of Contract with
                                  approved Vendor to another Budget Owner - A different budget owner appoints the same
                                  contractor or service provider who is currently engaged under an existing contract, to
                                  carry out equivalent works or services that fall within the scope or "boundary of that
                                  existing contract such as location, scope of work, etc, subject to the following
                                  conditions:
                                  <ul style={{ marginTop: "4px", paddingLeft: "20px", listStyle: "none" }}>
                                    <li>● The main contract must have been competitively tendered</li>
                                    <li>
                                      ● The extension is only applicable within six (6) months from the commencement
                                      date of the main contract.
                                    </li>
                                    <li>● The extension is allowed once only to another Budget Owner</li>
                                  </ul>
                                </div>
                              )}
                              {data.procurementNumber === "1g" && (
                                <div style={{ marginBottom: "30px" }}>
                                  1g. Direct Appointment (Based on Permissible Criteria) - Corporate Social
                                  Responsibility (CSR) Vendors - Selected primary to support an organization's CSR
                                  initiatives. Their appointment is based on their ability to contribute positively to
                                  social, environmental or community goals aligned with the organization's CSR
                                  commitments.
                                </div>
                              )}
                              {data.procurementNumber === "1h" && (
                                <div style={{ marginBottom: "30px" }}>
                                  1h. Direct Appointment (Based on Permissible Criteria) - Award of Contract Under Panel
                                  Vendor - Where vendors have been pre-qualified under an established panel or framework
                                  agreement.
                                </div>
                              )}
                              {data.procurementNumber === "1i" && (
                                <div style={{ marginBottom: "30px" }}>1i. Quotation Invitation (Offline)</div>
                              )}
                              {data.procurementNumber === "2" && (
                                <div style={{ marginBottom: "30px" }}>2. Open Tender</div>
                              )}
                              {data.procurementNumber === "3" && (
                                <div style={{ marginBottom: "30px" }}>3. Tender by Invitation</div>
                              )}
                              {data.procurementNumber === "4" && (
                                <div style={{ marginBottom: "30px" }}>4. Variation order / Extension of time</div>
                              )}
                            </div>
                          </Row>
                        )}
                      </Row>
                      <Row>
                        <Col
                          span={24}
                          style={{ textAlign: "right" }}
                        >
                          <Space>
                            <Button onClick={onCancelEdit}>Cancel</Button>
                            <Button
                              loading={isLoading}
                              type="primary"
                              onClick={() => handleSave(values)}
                            >
                              Save
                            </Button>
                          </Space>
                        </Col>
                      </Row>
                    </Form>
                  );
                }}
              </Formik>
            ) : (
              ""
            )}
          </Col>
          {!editMode && (
            <Col
              className="content-wrap"
              xs={24}
              md={24}
            >
              {getItemText("Project ID", data.projectId)}
            </Col>
          )}
          {!editMode && (
            <Col
              className="content-wrap"
              xs={24}
              md={24}
            >
              {getItemText("Project Name", data.projectTitle)}
            </Col>
          )}
          {!editMode && (
            <Col
              className="content-wrap"
              xs={24}
              md={24}
            >
              {getItemText("Budget", data.budget || "Uncategorized")}
            </Col>
          )}
          {!editMode && (
            <Col
              className="content-wrap"
              xs={24}
              md={24}
            >
              {getItemText("SPA Types", data.awardAndStrategyPaper || "Uncategorized")}
            </Col>
          )}
          {!editMode && (
            <Col
              className="content-wrap"
              xs={24}
              md={24}
            >
              {getItemText("Project Summary", data.projectSummary)}
            </Col>
          )}

          {!editMode && (
            <Col
              xs={24}
              md={8}
            >
              {getItemText(
                "Budget Amount/Pre-Tender Estimate (PTE)",
                !isTotalCost || isTotalCost == 0
                  ? "-"
                  : formatToDecimal(data?.currency?.totalCost, data?.currency?.currencyCode) || "-"
              )}
            </Col>
          )}

          {!editMode && (
            <Col
              xs={24}
              md={8}
            >
              {getItemText("Subsidiary/Division", data.subsidiary)}
            </Col>
          )}
          {!editMode && (
            <Col
              xs={24}
              md={8}
            >
              {getItemText("Cost Centre", data.division)}
            </Col>
          )}
        </Row>
        <Row>
          {!editMode && (
            <Col
              xs={24}
              md={8}
            >
              {getItemText("Status", upperFirst(data.status))}
            </Col>
          )}
          {!editMode && data.rejectReason && data.status === "rejected" && (
            <Col
              xs={24}
              md={8}
            >
              {getItemText("Reason for Rejection", data.rejectReason)}
            </Col>
          )}
          {!editMode && data.cancelReason && data.status === "cancelled" && (
            <Col
              xs={24}
              md={8}
            >
              {getItemText("Reason for Cancellation", data.cancelReason)}
            </Col>
          )}
        </Row>
        {!editMode && (
          <Row gutter={[16, 16]}>
            <div style={{ width: "100%", marginTop: "-10px" }}>
              {isMobile ? (
                <h4>A. Information on Procurement Process</h4>
              ) : (
                <h3>A. Information on Procurement Process</h3>
              )}
              {data.procurementNumber === "1a" && (
                <Col style={{ marginBottom: "30px", color: "black" }}>
                  1a. Direct Appointment (Based on Permissible Criteria) - OEM/Sole – The procurement of services, goods
                  or works through OEM, sole Agency proprietorship, sole distributorship and the likes.
                </Col>
              )}
              {data.procurementNumber === "1b" && (
                <Col style={{ marginBottom: "30px", color: "black" }}>
                  1b. Direct Appointment (Based on Permissible Criteria) - Wholly Owned Subsidiaries/Inter Companies –
                  The procurement of works, services and supplies from wholly owned subsidiaries/intercompanies.
                </Col>
              )}
              {data.procurementNumber === "1c" && (
                <Col style={{ marginBottom: "30px", color: "black" }}>
                  1c. Direct Appointment (Based on Permissible Criteria) - Government Sanctioned Rate – The Procurement
                  of services from any Government Agencies or any Government sanctioned bodies which is unavoidable for
                  purpose of certification or anything that is relevant to ensure business continuity of the
                  organization
                </Col>
              )}

              {data.procurementNumber === "1d" && (
                <Col style={{ marginBottom: "30px", color: "black" }}>
                  1d. Direct Appointment (Based on Permissible Criteria) - Emergency cases on Operation Critical nature-
                  The procurement of services and goods in emergency cases. Specifically, the term ‘Emergency’ shall be
                  confined to a situation where immediate, in-situ and impromptu attention and execution are a mission
                  critical in the even that a slight delay will may discontinue or may severely disrupt the operational
                  functions of the business entity, in general and the airport, in particular.
                </Col>
              )}
              {data.procurementNumber === "1e" && (
                <div style={{ marginBottom: "30px" }}>
                  1e. Specialist Consultancy Services - These services involve providing specific, unique and strategic
                  expertise tailored to meet the specialized needs including but not limited to procurement solutions,
                  legal advice, human resources, tax consultancy, and similar fields. The focus is on delivering expert
                  support that caters to the complexities of niche sectors.
                </div>
              )}
              {data.procurementNumber === "1f" && (
                <div style={{ marginBottom: "30px" }}>
                  1f. Direct Appointment (Based on Permissible Criteria) - Continuation of Contract with approved Vendor
                  to another Budget Owner - A different budget owner appoints the same contractor or service provider
                  who is currently engaged under an existing contract, to carry out equivalent works or services that
                  fall within the scope or boundary of that existing contract such as location, scope of work, etc.,
                  subject to the following conditions:
                  <ul style={{ marginTop: "4px", paddingLeft: "20px", listStyle: "none" }}>
                    <li>● The main contract must have been competitively tendered</li>
                    <li>
                      ● The extension is only applicable within six (6) months from the commencement date of the main
                      contract.
                    </li>
                    <li>● The extension is allowed once only to another Budget Owner</li>
                  </ul>
                </div>
              )}
              {data.procurementNumber === "1g" && (
                <div style={{ marginBottom: "30px" }}>
                  1g. Corporate Social Responsibility (CSR) Vendors - Selected primary to support an organization's CSR
                  initiatives. Their appointment is based on their ability to contribute positively to social,
                  environmental or community goals aligned with the organization's CSR commitments.
                </div>
              )}
              {data.procurementNumber === "1h" && (
                <div style={{ marginBottom: "30px" }}>
                  1h. Award of Contract Under Panel Vendor - Where vendors have been pre-qualified under an established
                  panel or framework agreement.
                </div>
              )}
              {data.procurementNumber === "1i" && (
                <div style={{ marginBottom: "30px" }}>1i. Quotation Invitation (Offline)</div>
              )}
              {data.procurementNumber === "2" && (
                <Col style={{ marginBottom: "30px", color: "black" }}>2. Open Tender</Col>
              )}
              {data.procurementNumber === "3" && (
                <Col style={{ marginBottom: "30px", color: "black" }}>3. Tender by Invitation</Col>
              )}
              {data.procurementNumber === "4" && (
                <Col style={{ marginBottom: "30px" }}>4. Variation order / Extension of time</Col>
              )}
            </div>

            <div style={{ width: "100%", marginTop: "-20px" }}>
              {isMobile ? (
                <h4>B. Summary of the Procurement (e.g Background, Evaluation & Justification) </h4>
              ) : (
                <h3 style={{ lineHeight: 1 }}>
                  B. Summary of the Procurement (e.g Background, Evaluation & Justification){" "}
                </h3>
              )}
              <Col
                className="content-wrap"
                style={{ overflowX: "auto" }}
              >
                {getItemText("", data.procurementSummary)}
              </Col>
            </div>

            <div style={{ width: "100%", marginTop: "15px" }}>
              {isMobile ? (
                <h4 style={{ marginTop: "-10px" }}>C. Recommendation</h4>
              ) : (
                <h3 style={{ marginTop: "-10px" }}>C. Recommendation</h3>
              )}
              <h4 style={{ fontWeight: 500 }}>Recommended Bidder/Vendor</h4>
              <Col
                className="content-wrap"
                style={{ marginTop: "10px" }}
              >
                {getItemText("", data.recommendedVendor)}
              </Col>
              {isMobile ? (
                <h4 style={{ fontWeight: 500 }}>Proposed Contract Value</h4>
              ) : (
                <h4 style={{ fontWeight: 500, lineHeight: 1 }}>Proposed Contract Value</h4>
              )}

              <Col className="content-wrap">{getItemText("", data.contractValue)}</Col>
              {isMobile ? (
                <h4 style={{ fontWeight: 500 }}>Proposed Contract Period</h4>
              ) : (
                <h4 style={{ fontWeight: 500, lineHeight: 1 }}>Proposed Contract Period</h4>
              )}

              <Col className="content-wrap">{getItemText("", data.contractPeriod)}</Col>
            </div>
          </Row>
        )}
      </WrapperCard>
      <Row style={{ marginTop: 10, marginBottom: 20 }}>
        {documents?.length >= 1 && (
          <ContractDocument
            isMobile={isMobile}
            title="Project Documents"
            documents={documents}
            id={id}
            type={"document"}
            rearrange={false}
            data
            fullEnvelopDetails
          />
        )}
      </Row>
      <Row gutter={16}>
        <Col span={24}>
          {data?.documentLinkDetails?.length > 0 && (
            <>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <Typography.Title level={isMobile ? 5 : 4}>Additional Document Link</Typography.Title>
                {((!editMode && data.status !== "completed" && hasKeyString("review") && data.status === "draft") ||
                  (hasKeyString("watcher") && data.status !== "draft") ||
                  (!hasKeyString("review") && data.status !== "draft" && data.status !== "completed")) && (
                  <Icon
                    icon="carbon:edit"
                    inline
                    className="doc-icon"
                    fontSize={24}
                    style={{
                      marginLeft: 8,
                      marginRight: 8,
                      cursor: "pointer",
                    }}
                    onClick={handleEditToggleDocuments}
                  />
                )}
              </div>
              <div style={{ marginBottom: "20px" }}>
                {data?.documentLinkDetails?.length > 0 ? (
                  data?.documentLinkDetails.map((doc: any, index: number) => (
                    <Row
                      key={index}
                      gutter={[16, 8]}
                      style={{ marginBottom: 8 }}
                    >
                      {isMobile ? (
                        <>
                          <Col span={24}>
                            <Typography.Title level={5}>Document Name</Typography.Title>
                            <Typography.Text>{doc?.name || "-"}</Typography.Text>
                          </Col>
                          <Col span={24}>
                            <Typography.Title level={5}>Document Link</Typography.Title>
                            {doc?.url ? (
                              <Typography.Link
                                target="_blank"
                                href={doc?.url ? decodeURIComponent(doc.url) : undefined}
                              >
                                {doc?.url ? decodeURIComponent(doc.url) : "-"}
                              </Typography.Link>
                            ) : (
                              <Typography.Text>-</Typography.Text>
                            )}
                          </Col>
                        </>
                      ) : (
                        <>
                          <Col span={6}>
                            <Typography.Title level={5}>Document Name</Typography.Title>
                            <Typography.Text>{doc?.name || "-"}</Typography.Text>
                          </Col>
                          <Col span={18}>
                            <Typography.Title level={5}>Document Link</Typography.Title>
                            {doc?.url ? (
                              <Typography.Link
                                target="_blank"
                                href={doc?.url ? decodeURIComponent(doc.url) : undefined}
                              >
                                {doc?.url ? decodeURIComponent(doc.url) : "-"}
                              </Typography.Link>
                            ) : (
                              <Typography.Text>-</Typography.Text>
                            )}
                          </Col>
                        </>
                      )}
                    </Row>
                  ))
                ) : (
                  <Typography.Text>-</Typography.Text>
                )}
              </div>
            </>
          )}

          {editedDocuments && (
            <Modal
              title="Edit Additional Document Link"
              visible={isModalVisible}
              onCancel={handleCancel}
              footer={[
                <>
                  <Button onClick={onCancelDocEdit}>Cancel</Button>
                  <Button
                    loading={isLoading}
                    key="save"
                    type="primary"
                    onClick={() => {
                      form.submit();
                    }}
                    disabled={hasErrors}
                  >
                    Save
                  </Button>
                </>,
              ]}
              maskClosable={false}
              closable={false}
            >
              <Formik
                initialValues={{
                  documentLinkDetails:
                    prevData.length > 0
                      ? prevData.map((doc) => {
                          const rawUrl = doc.newUrl ?? doc.oldUrl ?? doc.newValue ?? doc.oldValue ?? "";
                          return {
                            id: doc.id,
                            name: doc.newName || "",
                            url: rawUrl ? decodeURIComponent(rawUrl) : "",
                          };
                        })
                      : [{ id: uuidv4(), name: "", url: "" }],
                }}
                validationSchema={validationSchema2}
                onSubmit={prepareAndSubmitDocuments}
              >
                {({ values, handleChange, handleSubmit, setFieldValue, errors, isValid }) => {
                  useEffect(() => {
                    setHasErrors(!isValid && Object.keys(errors).length > 0);
                  }, [isValid, errors]);

                  return (
                    <Form
                      form={form}
                      onFinish={handleSubmit}
                      layout="vertical"
                    >
                      {values.documentLinkDetails.map((doc: any, index: number) => (
                        <Row
                          key={doc.id}
                          gutter={16}
                        >
                          <Col span={10}>
                            <Form.Item>
                              <Input
                                placeholder="Document Name"
                                value={doc.name}
                                onChange={(e) => setFieldValue(`documentLinkDetails[${index}].name`, e.target.value)}
                              />
                              <Typography.Text type="danger">
                                <ErrorMessage name={`documentLinkDetails[${index}].name`} />
                              </Typography.Text>
                            </Form.Item>
                          </Col>

                          <Col span={10}>
                            <Form.Item>
                              <Input
                                placeholder="Document Link"
                                value={doc.url}
                                onChange={(e) => setFieldValue(`documentLinkDetails[${index}].url`, e.target.value)}
                              />
                              <Typography.Text type="danger">
                                <ErrorMessage name={`documentLinkDetails[${index}].url`} />
                              </Typography.Text>
                            </Form.Item>
                          </Col>

                          <Col span={4}>
                            <Button
                              type="link"
                              danger
                              disabled={values.documentLinkDetails.length === 1}
                              onClick={() => {
                                const updated = [...values.documentLinkDetails];
                                updated.splice(index, 1);
                                setFieldValue("documentLinkDetails", updated);
                              }}
                            >
                              <Icon icon="fluent:delete-16-regular" />
                            </Button>
                          </Col>
                        </Row>
                      ))}

                      <Row>
                        <Col
                          span={24}
                          style={{ textAlign: "right" }}
                        >
                          <Button
                            type="text"
                            disabled={values.documentLinkDetails.some(
                              (doc: any) => !doc.name?.trim() || !doc.url?.trim()
                            )}
                            icon={<Icon icon="akar-icons:plus" />}
                            onClick={() =>
                              setFieldValue("documentLinkDetails", [
                                ...values.documentLinkDetails,
                                { id: uuidv4(), name: "", url: "" },
                              ])
                            }
                          >
                            Add File Link
                          </Button>
                        </Col>
                      </Row>
                    </Form>
                  );
                }}
              </Formik>
            </Modal>
          )}
        </Col>
      </Row>
      {budgetManagers && budgetManagers.length > 0 && (
        <WrapperCard
          isMobile={isMobile}
          title={" Budget Manager"}
          bodyClass="h-inherit"
          smallHeader
        >
          <Row>
            <Col span={24}>
              <DataTable
                height={400}
                multiSelect={false}
                tableData={map(budgetManagers, (license, i) => ({
                  ...license,
                  key: i,
                }))}
                columns={[
                  {
                    title: "Designation",
                    dataIndex: "designation",
                    render: (value: any) => value || <Typography.Text disabled>-</Typography.Text>,
                  },
                  {
                    title: "Name",
                    dataIndex: "name",
                    render: (value: any) => value || <Typography.Text disabled>-</Typography.Text>,
                  },
                  {
                    title: "Email Address",
                    dataIndex: "emailAddress",
                    render: (value: any) => value || <Typography.Text disabled>-</Typography.Text>,
                  },
                  {
                    title: "Status",
                    dataIndex: "status",
                    render: (value: any) => getColor(value) || <Typography.Text disabled>-</Typography.Text>,
                  },
                  {
                    title: "Reviewed At",
                    dataIndex: "reviewedAt",
                    render: (value: any) =>
                      value ? (
                        <Typography.Text>{getFormattedDate(value)}</Typography.Text>
                      ) : (
                        <Typography.Text disabled>-</Typography.Text>
                      ),
                    ellipsis: true,
                  },
                  {
                    title: "Subsidiary/Division",
                    dataIndex: "subsidiary",
                    render: (value: any) => value || <Typography.Text disabled>-</Typography.Text>,
                  },
                  {
                    title: "Cost Centre",
                    dataIndex: "division",
                    render: (value: any) => value || <Typography.Text disabled>-</Typography.Text>,
                  },
                ]}
                showTopBar={false}
              />
            </Col>
          </Row>
        </WrapperCard>
      )}
      <Row style={{ marginTop: "50px" }}>
        {oneStopCentre?.length > 0 && (
          <WrapperCard
            isMobile={isMobile}
            title={"Secretariat, PCD"}
            bodyClass="h-inherit"
            smallHeader
          >
            <Row>
              <Col span={24}>
                <DataTable
                  height={400}
                  multiSelect={false}
                  tableData={map(oneStopCentre, (license, i) => ({
                    ...license,
                    key: i,
                  }))}
                  columns={[
                    {
                      title: "Designation",
                      dataIndex: "designation",
                      render: (value: any) => value || <Typography.Text disabled>-</Typography.Text>,
                    },
                    {
                      title: "Name",
                      dataIndex: "name",
                      render: (value: any) => value || <Typography.Text disabled>-</Typography.Text>,
                    },
                    {
                      title: "Email Address",
                      dataIndex: "emailAddress",
                      render: (value: any) => value || <Typography.Text disabled>-</Typography.Text>,
                    },
                    {
                      title: "Status",
                      dataIndex: "status",
                      render: (value: any) =>
                        value === "pending" ? <Typography.Text disabled>-</Typography.Text> : getColor(value),
                    },
                    {
                      title: "Reviewed At",
                      dataIndex: "reviewedAt",
                      render: (value: any) =>
                        value ? (
                          <Typography.Text>{getFormattedDate(value)}</Typography.Text>
                        ) : (
                          <Typography.Text disabled>-</Typography.Text>
                        ),
                      ellipsis: true,
                    },
                  ]}
                  showTopBar={false}
                />
              </Col>
            </Row>
          </WrapperCard>
        )}
      </Row>
      {data.approvalAuthority === "airportManager" ? (
        <>
          <Row style={{ marginTop: "50px" }}>
            {airportAPC && (
              <WrapperCard
                isMobile={isMobile}
                title={"APC Secretariat"}
                bodyClass="h-inherit"
                smallHeader
                action={
                  <>
                    {((hasKeyString("watcher") && data.status !== "draft") ||
                      (!hasKeyString("review") &&
                        isMasterAdmin?.isMasterAdmin &&
                        data.status !== "draft" &&
                        data.status !== "completed")) && (
                      <Icon
                        icon="carbon:edit"
                        inline
                        className="doc-icon"
                        fontSize={24}
                        style={{
                          marginLeft: 8,
                          marginRight: 8,
                        }}
                        cursor="pointer"
                        onClick={handleEditAirportSectretariatToggle}
                      />
                    )}
                  </>
                }
              >
                <Row>
                  <Col span={24}>
                    <DataTable
                      height={400}
                      multiSelect={false}
                      tableData={map(airportAPC, (license, i) => ({
                        ...license,
                        key: i,
                      }))}
                      columns={[
                        {
                          title: "Designation",
                          dataIndex: "designation",
                          render: (value: any) => value || <Typography.Text disabled>-</Typography.Text>,
                        },
                        {
                          title: "Name",
                          dataIndex: "name",
                          render: (value: any) => value || <Typography.Text disabled>-</Typography.Text>,
                        },
                        {
                          title: "Email Address",
                          dataIndex: "emailAddress",
                          render: (value: any) => value || <Typography.Text disabled>-</Typography.Text>,
                        },
                        {
                          title: "Status",
                          dataIndex: "status",
                          render: (value: any, record: any) => {
                            const { name, designation, emailAddress, reviewedAt } = record;
                            const isAllEmpty = !name && !designation && !emailAddress && !reviewedAt;
                            if (isAllEmpty || value === "pending") {
                              return <Typography.Text disabled>-</Typography.Text>;
                            }

                            return getColor(value);
                          },
                        },
                        {
                          title: "Reviewed At",
                          dataIndex: "reviewedAt",
                          render: (value: any) =>
                            value ? (
                              <Typography.Text>{getFormattedDate(value)}</Typography.Text>
                            ) : (
                              <Typography.Text disabled>-</Typography.Text>
                            ),
                          ellipsis: true,
                        },
                      ]}
                      showTopBar={false}
                    />
                  </Col>
                </Row>
              </WrapperCard>
            )}
          </Row>

          <Row style={{ marginTop: "50px" }}>
            {airportAPCMember && (
              <WrapperCard
                isMobile={isMobile}
                title={"APC Members"}
                bodyClass="h-inherit"
                smallHeader
                action={
                  <>
                    {((hasKeyString("watcher") && data.status !== "draft") ||
                      (!hasKeyString("review") &&
                        isMasterAdmin?.isMasterAdmin &&
                        data.status !== "draft" &&
                        data.status !== "completed")) && (
                      <Icon
                        icon="carbon:edit"
                        inline
                        className="doc-icon"
                        fontSize={24}
                        style={{
                          marginLeft: 8,
                          marginRight: 8,
                        }}
                        cursor="pointer"
                        onClick={handleEditApcMemberToggle}
                      />
                    )}
                  </>
                }
              >
                <Row>
                  <Col span={24}>
                    <DataTable
                      height={400}
                      multiSelect={false}
                      tableData={map(airportAPCMember, (license, i) => ({
                        ...license,
                        key: i,
                      }))}
                      columns={[
                        {
                          title: "Designation",
                          dataIndex: "designation",
                          render: (value: any) => value || <Typography.Text disabled>-</Typography.Text>,
                        },
                        {
                          title: "Name",
                          dataIndex: "name",
                          render: (value: any) => value || <Typography.Text disabled>-</Typography.Text>,
                        },
                        {
                          title: "Email Address",
                          dataIndex: "emailAddress",
                          render: (value: any) => value || <Typography.Text disabled>-</Typography.Text>,
                        },
                        {
                          title: "Status",
                          dataIndex: "status",
                          render: (value: any, record: any) => {
                            const { name, designation, emailAddress, reviewedAt } = record;
                            const isAllEmpty = !name && !designation && !emailAddress && !reviewedAt;
                            if (isAllEmpty || value === "pending") {
                              return <Typography.Text disabled>-</Typography.Text>;
                            }

                            return getColor(value);
                          },
                        },
                        {
                          title: "Reviewed At",
                          dataIndex: "reviewedAt",
                          render: (value: any) =>
                            value ? (
                              <Typography.Text>{getFormattedDate(value)}</Typography.Text>
                            ) : (
                              <Typography.Text disabled>-</Typography.Text>
                            ),
                          ellipsis: true,
                        },
                      ]}
                      showTopBar={false}
                    />
                  </Col>
                </Row>
              </WrapperCard>
            )}
          </Row>

          <Row style={{ marginTop: "50px" }}>
            {airportManager && (
              <WrapperCard
                isMobile={isMobile}
                action={
                  <>
                    {((hasKeyString("watcher") && data.status !== "draft") ||
                      (!hasKeyString("review") &&
                        isMasterAdmin?.isMasterAdmin &&
                        data.status !== "draft" &&
                        data.status !== "completed")) && (
                      <Icon
                        icon="carbon:edit"
                        inline
                        className="doc-icon"
                        fontSize={24}
                        style={{
                          marginLeft: 8,
                          marginRight: 8,
                        }}
                        cursor="pointer"
                        onClick={handleEditAirportToggle}
                      />
                    )}
                  </>
                }
                title={"Airport Manager"}
                bodyClass="h-inherit"
                smallHeader
              >
                <Row>
                  <Col span={24}>
                    <DataTable
                      height={400}
                      multiSelect={false}
                      tableData={map(airportManager, (license, i) => ({
                        ...license,
                        key: i,
                      }))}
                      columns={[
                        {
                          title: "Designation",
                          dataIndex: "designation",
                          render: (value: any) => value || <Typography.Text disabled>-</Typography.Text>,
                        },
                        {
                          title: "Name",
                          dataIndex: "name",
                          render: (value: any) => value || <Typography.Text disabled>-</Typography.Text>,
                        },
                        {
                          title: "Email Address",
                          dataIndex: "emailAddress",
                          render: (value: any) => value || <Typography.Text disabled>-</Typography.Text>,
                        },
                        {
                          title: "Status",
                          dataIndex: "status",
                          render: (value: any, record: any) => {
                            const { name, designation, emailAddress, reviewedAt } = record;
                            const isAllEmpty = !name && !designation && !emailAddress && !reviewedAt;
                            if (isAllEmpty || value === "pending") {
                              return <Typography.Text disabled>-</Typography.Text>;
                            }

                            return getColor(value);
                          },
                        },
                        {
                          title: "Reviewed At",
                          dataIndex: "reviewedAt",
                          render: (value: any) =>
                            value ? (
                              <Typography.Text>{getFormattedDate(value)}</Typography.Text>
                            ) : (
                              <Typography.Text disabled>-</Typography.Text>
                            ),
                          ellipsis: true,
                        },
                      ]}
                      showTopBar={false}
                    />
                  </Col>
                </Row>
              </WrapperCard>
            )}
          </Row>
        </>
      ) : (
        <>
          <Row style={{ marginTop: "50px" }}>
            {approvers && (
              <WrapperCard
                isMobile={isMobile}
                action={
                  <>
                    {((hasKeyString("watcher") && data.status !== "draft") ||
                      (!hasKeyString("review") &&
                        isMasterAdmin?.isMasterAdmin &&
                        data.status !== "draft" &&
                        data.status !== "completed")) && (
                      <Icon
                        icon="carbon:edit"
                        inline
                        className="doc-icon"
                        fontSize={24}
                        style={{
                          marginLeft: 8,
                          marginRight: 8,
                        }}
                        cursor="pointer"
                        onClick={handleEditApproversToggle}
                      />
                    )}
                  </>
                }
                title={"Approvers"}
                bodyClass="h-inherit"
                smallHeader
              >
                <Row>
                  <Col span={24}>
                    <DataTable
                      height={400}
                      multiSelect={false}
                      tableData={map(approvers, (license, i) => ({
                        ...license,
                        key: i,
                      }))}
                      columns={[
                        {
                          title: "Designation",
                          dataIndex: "designation",
                          render: (value: any) => value || <Typography.Text disabled>-</Typography.Text>,
                        },
                        {
                          title: "Name",
                          dataIndex: "name",
                          render: (value: any) => value || <Typography.Text disabled>-</Typography.Text>,
                        },
                        {
                          title: "Email Address",
                          dataIndex: "emailAddress",
                          render: (value: any) => value || <Typography.Text disabled>-</Typography.Text>,
                        },
                        {
                          title: "Status",
                          dataIndex: "status",
                          render: (value: any, record: any) => {
                            const { name, designation, emailAddress, reviewedAt } = record;
                            const isAllEmpty = !name && !designation && !emailAddress && !reviewedAt;
                            if (isAllEmpty || value === "pending") {
                              return <Typography.Text disabled>-</Typography.Text>;
                            }

                            return getColor(value);
                          },
                        },
                        {
                          title: "Reviewed At",
                          dataIndex: "reviewedAt",
                          render: (value: any) =>
                            value ? (
                              <Typography.Text>{getFormattedDate(value)}</Typography.Text>
                            ) : (
                              <Typography.Text disabled>-</Typography.Text>
                            ),
                          ellipsis: true,
                        },
                      ]}
                      showTopBar={false}
                    />
                  </Col>
                </Row>
              </WrapperCard>
            )}
          </Row>
        </>
      )}

      <Row style={{ marginTop: "50px" }}>
        {sortedWatchers && (
          <WrapperCard
            isMobile={isMobile}
            action={
              <>
                {((hasKeyString("watcher") && data.status !== "draft") ||
                  (!hasKeyString("review") &&
                    isMasterAdmin?.isMasterAdmin &&
                    data.status !== "draft" &&
                    data.status !== "completed")) && (
                  <Icon
                    icon="carbon:edit"
                    inline
                    className="doc-icon"
                    fontSize={24}
                    style={{
                      marginLeft: 8,
                      marginRight: 8,
                    }}
                    cursor="pointer"
                    onClick={handleEditWatchersToggle}
                  />
                )}
              </>
            }
            title={"Watchers"}
            bodyClass="h-inherit"
            smallHeader
          >
            <Row>
              <Col span={24}>
                <DataTable
                  height={400}
                  multiSelect={false}
                  tableData={map(sortedWatchers, (license, i) => ({
                    ...license,
                    key: i,
                  }))}
                  columns={[
                    {
                      title: "Reviewer",
                      dataIndex: "role",
                      render: (value: any) => {
                        const displayValue = value === "PCD" ? "PCD" : value;
                        return displayValue || <Typography.Text disabled>-</Typography.Text>;
                      },
                    },
                    {
                      title: "Name",
                      dataIndex: "name",
                      render: (value: any) => value || <Typography.Text disabled>-</Typography.Text>,
                    },
                    {
                      title: "Email Address",
                      dataIndex: "emailAddress",
                      render: (value: any) => value || <Typography.Text disabled>-</Typography.Text>,
                    },
                    {
                      title: "Sent At",
                      dataIndex: "sentAt",
                      render: (value: any) =>
                        value ? (
                          <Typography.Text>{getFormattedDate(value)}</Typography.Text>
                        ) : (
                          <Typography.Text disabled>-</Typography.Text>
                        ),
                      ellipsis: true,
                    },
                  ]}
                  showTopBar={false}
                />
              </Col>
            </Row>
          </WrapperCard>
        )}
      </Row>
      {screens.xs ? (
        <div style={{ overflow: "auto" }}>
          {hasKeyString("review") &&
            data.status !== "draft" &&
            ((data.approvalAuthority === "airportManager" &&
              review?.[0]?.emailAddress === user?.email &&
              review?.[0]?.status === "In-Progress") ||
              (isManagerInProgress && data?.status !== "completed") ||
              (data.approvalAuthority !== "airportManager" &&
                !isReviewerApproved(user.email, reviewers, data) &&
                data.status !== "cancelled" &&
                data.status !== "expired")) && (
              <Row
                style={{ marginTop: 25 }}
                gutter={[8, 8]}
                justify={"end"}
              >
                <Col
                  xs={24}
                  sm={12}
                  md={8}
                  lg={6}
                  xl={4}
                  style={{ order: 3 }}
                >
                  <Button
                    onClick={() => {
                      setModal(true);
                    }}
                    type="ghost"
                    block
                  >
                    Return with Comment
                  </Button>
                </Col>
                <Col
                  xs={24}
                  sm={12}
                  md={8}
                  lg={6}
                  xl={4}
                  style={{ order: 2 }}
                >
                  <Button
                    onClick={() => handleSendReject(true)}
                    style={{ backgroundColor: "#d11a2a", color: "white" }}
                    block
                  >
                    Reject
                  </Button>
                </Col>
                <Col
                  xs={24}
                  sm={12}
                  md={8}
                  lg={6}
                  xl={4}
                  style={{ order: 1 }}
                >
                  <Button
                    onClick={() => handleSendSigning(true)}
                    type="primary"
                    block
                  >
                    Approve
                  </Button>
                </Col>
              </Row>
            )}

          {query.get("enable") == "return" && data?.status !== "completed" && data?.status !== "draft" && (
            <Row style={{ display: "flex", justifyContent: "end", marginTop: "20px" }}>
              <Button
                onClick={() => {
                  setModal(true);
                }}
                type="primary"
              >
                Return with Comment
              </Button>
            </Row>
          )}

          <Row style={{ display: "flex", justifyContent: "end", marginTop: "20px" }}>
            {hasRole(["SPA_ADMIN"]) &&
              query.get("enable") !== "return" &&
              data?.status !== "completed" &&
              data.status !== "cancelled" &&
              data.status !== "draft" &&
              !hasKeyString("review") && (
                <Button
                  style={{ backgroundColor: "#d11a2a", color: "white" }}
                  onClick={() => {
                    onCancelModal(true);
                  }}
                  type="ghost"
                >
                  Cancel
                </Button>
              )}

            {(hasRole(["SPA_ADMIN"]) || data?.ownersEmail === userEmail) &&
              data?.status !== "completed" &&
              data?.status !== "draft" &&
              query.get("enable") === "resend" && (
                <Button
                  style={{ marginLeft: "10px" }}
                  disabled={data.status === "completed"}
                  onClick={() => onResend()}
                  type="primary"
                >
                  Resend/Reply
                </Button>
              )}
          </Row>
        </div>
      ) : (
        <>
          {hasKeyString("review") &&
            data.status !== "draft" &&
            ((data.approvalAuthority === "airportManager" &&
              review?.[0]?.emailAddress === user?.email &&
              review?.[0]?.status === "In-Progress") ||
              (isManagerInProgress && data?.status !== "completed") ||
              (data.approvalAuthority !== "airportManager" &&
                !isReviewerApproved(user.email, reviewers, data) &&
                data.status !== "cancelled" &&
                data.status !== "expired")) && (
              <Row style={{ marginTop: 25, gap: 10, flexFlow: "row-reverse" }}>
                <Button
                  onClick={() => handleSendSigning(true)}
                  type="primary"
                >
                  Approve
                </Button>
                <Button
                  onClick={() => handleSendReject(true)}
                  style={{ backgroundColor: "#d11a2a", color: "white" }}
                >
                  Reject
                </Button>
                <Button
                  onClick={() => {
                    setModal(true);
                  }}
                  type="ghost"
                >
                  Return with Comment
                </Button>
              </Row>
            )}

          <Row style={{ display: "flex", justifyContent: "end", marginTop: "20px", gap: 10 }}>
            {hasRole(["SPA_ADMIN"]) &&
              user.email === pcdDetail?.emailAddress &&
              query.get("enable") == "return" &&
              data?.status !== "completed" &&
              data.status !== "cancelled" &&
              data.status !== "draft" &&
              !hasKeyString("review") && (
                <Button
                  style={{ backgroundColor: "#d11a2a", color: "white" }}
                  onClick={() => {
                    onCancelModal(true);
                  }}
                  type="ghost"
                >
                  Cancel
                </Button>
              )}

            {query.get("enable") == "return" && data?.status !== "completed" && data?.status !== "draft" && (
              <Button
                onClick={() => {
                  setModal(true);
                }}
                type="primary"
              >
                Return with Comment
              </Button>
            )}
          </Row>

          <Row style={{ display: "flex", justifyContent: "end", marginTop: "20px" }}>
            {hasRole(["SPA_ADMIN"]) &&
              query.get("enable") !== "return" &&
              data?.status !== "completed" &&
              data.status !== "cancelled" &&
              data.status !== "draft" &&
              !hasKeyString("review") && (
                <Button
                  style={{ backgroundColor: "#d11a2a", color: "white" }}
                  onClick={() => {
                    onCancelModal(true);
                  }}
                  type="ghost"
                >
                  Cancel
                </Button>
              )}

            {(hasRole(["SPA_ADMIN"]) || data?.ownersEmail === userEmail) &&
              data?.status !== "completed" &&
              data?.status !== "draft" &&
              query.get("enable") === "resend" && (
                <Button
                  style={{ marginLeft: "10px" }}
                  disabled={data.status === "completed"}
                  onClick={() => onResend()}
                  type="primary"
                >
                  Resend/Reply
                </Button>
              )}
          </Row>
        </>
      )}

      <Formik
        onSubmit={(values, formikHelpers) => {
          const processedComment = processMessageWithUrls(values.message);
          setCommentLoading(true);
          const formdata = JSON.stringify({
            envelopeId: id,
            documentId: values.documentId,
            comment: processedComment,
            commenterRole: commenterRole ? "approver" : "watcher",
          });
          api
            .post("v1/workflow/comments", formdata, {
              headers: {
                "Content-Type": "application/json",
              },
            })
            .then((res) => {
              setCommentLoading(false);
              formikHelpers.resetForm();
              setModal(false);
              setSuccessOpen(true);
            })
            .catch((err) => {
              openNotification({
                title: "Error",
                message: "Request Failed",
                type: "error",
              });
              console.log(err);
              setCommentLoading(false);
            });
        }}
        initialValues={initialValue}
        validationSchema={commentsValidationSchema}
      >
        {({ submitForm, resetForm, setFieldValue, touched, errors, isValid, dirty, values }) => {
          return (
            <Modal
              title={"Comments"}
              maskClosable={false}
              open={modal}
              onOk={() => {
                submitForm();
              }}
              okButtonProps={{ disabled: !(isValid && dirty) }}
              onCancel={() => {
                setModal(false);
                resetForm();
              }}
              confirmLoading={commentLoading}
              okText={"Comment"}
              width={600}
              centered
            >
              <Form
                layout="vertical"
                onFinish={submitForm}
              >
                <Field name={"documentId"}>
                  {({ field, meta }: FieldProps) => {
                    return (
                      <Form.Item
                        label={"Please choose the document you would like to comment on"}
                        validateStatus={meta.touched && meta.error ? "error" : ""}
                      >
                        <Select
                          style={{ width: "100%" }}
                          size={"middle"}
                          {...field}
                          value={field.value}
                          onChange={(e) => {
                            setFieldValue("documentId", e);
                          }}
                        >
                          {documents &&
                            documents?.map((item: any, index: number) => {
                              return (
                                <Select.Option
                                  value={item.documentId}
                                  key={item.documentId + index}
                                >
                                  {item.documentName}
                                </Select.Option>
                              );
                            })}
                        </Select>
                        {meta.touched && meta.error && (
                          <Typography.Text type="danger">{meta.error.toString()}</Typography.Text>
                        )}
                      </Form.Item>
                    );
                  }}
                </Field>
                <Field name={"message"}>
                  {({ field, meta }: FieldProps) => {
                    return (
                      <>
                        <Form.Item
                          label={"Please comment regarding the document"}
                          validateStatus={meta.touched && meta.error ? "error" : ""}
                        >
                          <TextArea
                            rows={4}
                            maxLength={5000}
                            showCount
                            {...field}
                          />
                          {meta.touched && meta.error && (
                            <Typography.Text type="danger">{meta.error.toString()}</Typography.Text>
                          )}
                        </Form.Item>
                      </>
                    );
                  }}
                </Field>
              </Form>
            </Modal>
          );
        }}
      </Formik>
      <Modal
        title={"Add Fields"}
        maskClosable={false}
        open={isModalOpen}
        onOk={() => {
          setIsModalOpen(false);
        }}
        onCancel={() => {
          setIsModalOpen(false);
        }}
        okButtonProps={{ hidden: true }}
        width={window.innerWidth <= 1000 ? window.innerWidth : window.innerWidth - window.innerWidth * 0.1}
        bodyStyle={{ height: window.innerHeight - 150, overflowY: "scroll" }}
        centered
      >
        <iframe
          title="External Page"
          src={url}
          width="100%"
          height="100%"
          frameBorder="0"
        />
      </Modal>
      <SuccessModal
        message={""}
        title={"You have successfully commented on document"}
        type={"success"}
        buttonText={"Go Back"}
        redirect={
          query.get("enable") == "return"
            ? `/spa-watcher/view/${id}?activeTab=comments`
            : hasKeyString("review")
              ? `/spa-review/view/${id}?activeTab=comments`
              : ""
        }
        reTrigger={handleTrigger}
        open={successOpen}
        setOpen={setSuccessOpen}
      />
      <ApprovalModal
        reTrigger={handleTrigger}
        commentModal={openSigningModal}
        name={data.projectTitle}
        id={id}
        openModal={openApproveModal}
        openCancelModal={openCancelModal}
        handlePlaceHolder={handlePlaceHolder}
        Signing={handleSendSigning}
        handleReject={handleSendReject}
        handleCancel={onCancelModal}
        handleSending={handleSend}
        openRejectModal={openRejectModal}
        openSendingModal={openSendingModal}
      />
      <ResendModal
        onSuccess={() => {
          setOpenResendModal(false);
          detailsTrigger(true);
        }}
        id={id}
        showResendModal={openResendModal}
        onCancel={() => setOpenResendModal(false)}
      />
      {hasKeyString("review") && isMangerNotApplicable && (
        <Modal
          open={isModal}
          maskClosable={false}
          closable={false}
          footer={[
            <Button
              key="ok"
              type="primary"
              onClick={() => navigate("/spa")}
            >
              OK
            </Button>,
          ]}
        >
          <>
            <Typography.Text>
              The majority of votes have already been considered You cannot take further action on this request. Thank
              you.
            </Typography.Text>
          </>
        </Modal>
      )}
      <Modal
        width={1000}
        open={openApproverModal}
        maskClosable={false}
        closable={false}
        title="Edit Approvers"
        onCancel={handleApproverCancel}
        okText="Save"
        footer={null}
      >
        <Spin spinning={loadingApproverList}>
          <Formik
            enableReinitialize
            initialValues={{
              approvers: approvers,
            }}
            onSubmit={handleApproversEditSubmit}
          >
            {(props) => {
              const allowedDesignations = ["GCFO", "GCOO", "COO", "CAO", "CFO"];
              const designations = [
                ...new Set(approverList.filter((item: any) => item.designation).map((item: any) => item.designation)),
              ];
              const hasAllowedDesignation = designations.some((designation: string) =>
                allowedDesignations.includes(designation)
              );
              return (
                <Form layout="vertical">
                  {props.values.approvers.map((approver: any, i: any) => {
                    const isLastApprover = i === props.values.approvers.length - 1;
                    const filteredUsers = approverList.filter((item: any) => {
                      if (isLastApprover && hasAllowedDesignation) {
                        return (
                          item?.designation === approver?.designation || allowedDesignations.includes(item?.designation)
                        );
                      } else {
                        return item?.designation === approver?.designation;
                      }
                    });

                    return (
                      <Row
                        gutter={16}
                        key={i}
                      >
                        {/* Designation */}
                        <Col span={8}>
                          <Form.Item label="Designation">
                            <Field name={`approvers.${i}.designation`}>
                              {({ field }: FieldProps) => (
                                <Input
                                  {...field}
                                  placeholder="Enter designation"
                                  disabled
                                />
                              )}
                            </Field>
                            <Typography.Text type="danger">
                              <ErrorMessage name={`approvers.${i}.designation`} />
                            </Typography.Text>
                          </Form.Item>
                        </Col>

                        {/* Name */}
                        <Col span={8}>
                          <Form.Item label="Name">
                            <Field name={`approvers.${i}.name`}>
                              {({ field }: FieldProps) => (
                                <Select
                                  {...field}
                                  showSearch
                                  placeholder="Select name"
                                  style={{ width: "100%" }}
                                  onChange={(value) => {
                                    field.onChange({ target: { name: field.name, value } });
                                    const selectedUser = approverList.find((item: any) => item?.userName === value);
                                    if (selectedUser) {
                                      props.setFieldValue(`approvers.${i}.emailAddress`, selectedUser.userEmail);
                                      if (isLastApprover && hasAllowedDesignation) {
                                        props.setFieldValue(`approvers.${i}.designation`, selectedUser.designation);
                                      }
                                    }
                                  }}
                                >
                                  {filteredUsers.map((item: any, index: number) => (
                                    <Select.Option
                                      key={index}
                                      value={item?.userName}
                                    >
                                      {item?.userName}
                                    </Select.Option>
                                  ))}
                                </Select>
                              )}
                            </Field>
                            <Typography.Text type="danger">
                              <ErrorMessage name={`approvers.${i}.name`} />
                            </Typography.Text>
                          </Form.Item>
                        </Col>

                        {/* Email */}
                        <Col span={8}>
                          <Form.Item label="Email Address">
                            <Field name={`approvers.${i}.emailAddress`}>
                              {({ field }: FieldProps) => (
                                <Select
                                  {...field}
                                  showSearch
                                  placeholder="Select email"
                                  style={{ width: "100%" }}
                                  onChange={(value) => {
                                    field.onChange({ target: { name: field.name, value } });
                                    const selectedUser = approverList.find((item: any) => item?.userEmail === value);
                                    if (selectedUser) {
                                      props.setFieldValue(`approvers.${i}.name`, selectedUser.userName);
                                      if (isLastApprover && hasAllowedDesignation) {
                                        props.setFieldValue(`approvers.${i}.designation`, selectedUser.designation);
                                      }
                                    }
                                  }}
                                >
                                  {filteredUsers.map((item: any, index: number) => (
                                    <Select.Option
                                      key={index}
                                      value={item?.userEmail}
                                    >
                                      {item?.userEmail}
                                    </Select.Option>
                                  ))}
                                </Select>
                              )}
                            </Field>
                            <Typography.Text type="danger">
                              <ErrorMessage name={`approvers.${i}.emailAddress`} />
                            </Typography.Text>
                          </Form.Item>
                        </Col>
                      </Row>
                    );
                  })}
                  <div style={{ marginTop: 24, textAlign: "right" }}>
                    <Button
                      onClick={handleApproverCancel}
                      style={{ marginRight: 8 }}
                    >
                      Cancel
                    </Button>
                    <Button
                      type="primary"
                      onClick={() => props.handleSubmit()}
                    >
                      Save
                    </Button>
                  </div>
                </Form>
              );
            }}
          </Formik>
        </Spin>
      </Modal>
      <Modal
        width={1000}
        open={openAirportModal}
        maskClosable={false}
        closable={false}
        title="Edit Airport Managers"
        okText="Save"
        footer={null}
      >
        <Spin spinning={loadingAirportList}>
          <Formik
            enableReinitialize
            initialValues={{
              approvers: airportManager,
            }}
            onSubmit={handleApproversEditSubmit}
          >
            {(props) => {
              const airportManagersOnly = airportManagerList.filter(
                (item: any) => item.designation === "AIRPORT MANAGER"
              );
              return (
                <Form layout="vertical">
                  {props.values.approvers.map((approver: any, i: any) => {
                    return (
                      <Row
                        gutter={16}
                        key={i}
                      >
                        {/* Designation */}
                        <Col span={8}>
                          <Form.Item label="Designation">
                            <Field name={`approvers.${i}.designation`}>
                              {({ field }: FieldProps) => (
                                <Input
                                  {...field}
                                  placeholder="Enter designation"
                                  disabled
                                />
                              )}
                            </Field>
                            <Typography.Text type="danger">
                              <ErrorMessage name={`approvers.${i}.designation`} />
                            </Typography.Text>
                          </Form.Item>
                        </Col>

                        {/* Name */}
                        <Col span={8}>
                          <Form.Item label="Name">
                            <Field name={`approvers.${i}.name`}>
                              {({ field }: FieldProps) => (
                                <Select
                                  showSearch
                                  placeholder="Select name"
                                  value={approver.name}
                                  onChange={(value) => {
                                    const selectedUser = airportManagersOnly.find(
                                      (item: any) => item.userName === value
                                    );

                                    if (selectedUser) {
                                      props.setFieldValue(`approvers.${i}.name`, selectedUser.userName);
                                      props.setFieldValue(`approvers.${i}.emailAddress`, selectedUser.userEmail);
                                      props.setFieldValue(`approvers.${i}.designation`, selectedUser.designation);
                                    }
                                  }}
                                >
                                  {airportManagersOnly.map((item: any) => (
                                    <Select.Option
                                      key={item.uniqueId}
                                      value={item.userName}
                                    >
                                      {item.userName}
                                    </Select.Option>
                                  ))}
                                </Select>
                              )}
                            </Field>
                            <Typography.Text type="danger">
                              <ErrorMessage name={`approvers.${i}.name`} />
                            </Typography.Text>
                          </Form.Item>
                        </Col>

                        {/* Email */}
                        <Col span={8}>
                          <Form.Item label="Email Address">
                            <Field name={`approvers.${i}.emailAddress`}>
                              {({ field }: FieldProps) => (
                                <Select
                                  showSearch
                                  placeholder="Select email"
                                  value={approver.emailAddress}
                                  onChange={(value) => {
                                    const selectedUser = airportManagersOnly.find(
                                      (item: any) => item.userEmail === value
                                    );

                                    if (selectedUser) {
                                      props.setFieldValue(`approvers.${i}.emailAddress`, selectedUser.userEmail);
                                      props.setFieldValue(`approvers.${i}.name`, selectedUser.userName);
                                      props.setFieldValue(`approvers.${i}.designation`, selectedUser.designation);
                                    }
                                  }}
                                >
                                  {airportManagersOnly.map((item: any) => (
                                    <Select.Option
                                      key={item.uniqueId}
                                      value={item.userEmail}
                                    >
                                      {item.userEmail}
                                    </Select.Option>
                                  ))}
                                </Select>
                              )}
                            </Field>
                            <Typography.Text type="danger">
                              <ErrorMessage name={`approvers.${i}.emailAddress`} />
                            </Typography.Text>
                          </Form.Item>
                        </Col>
                      </Row>
                    );
                  })}
                  <div style={{ marginTop: 24, textAlign: "right" }}>
                    <Button
                      onClick={handleAirportCancel}
                      style={{ marginRight: 8 }}
                    >
                      Cancel
                    </Button>
                    <Button
                      type="primary"
                      onClick={() => props.handleSubmit()}
                    >
                      Save
                    </Button>
                  </div>
                </Form>
              );
            }}
          </Formik>
        </Spin>
      </Modal>
      <Modal
        width={1000}
        open={openWatcherModal}
        maskClosable={false}
        closable={false}
        title="Edit Watchers"
        onCancel={handleWatcherCancel}
        okText="Save"
        footer={null}
      >
        <Spin spinning={loadingApproverList || loadingPcdList}>
          <Formik
            enableReinitialize
            initialValues={{
              watchers: watchers,
            }}
            onSubmit={handleApproversEditSubmit}
            validationSchema={watcherValidationSchema}
          >
            {(props) => {
              return (
                <Form layout="vertical">
                  {props.values.watchers.map((watcher: any, i: any) => {
                    const isPCD = watcher.role === "PCD";
                    return (
                      <Row
                        gutter={16}
                        key={i}
                      >
                        <Col span={8}>
                          <Form.Item label="Reviewer">
                            <Field name={`watchers.${i}.role`}>
                              {({ field }: FieldProps) => {
                                const displayValue = field.value === "PCD" ? "PCD" : field.value;
                                return(
                                <Input
                                  {...field}
                                  value={displayValue}
                                  placeholder="Enter designation"
                                  disabled
                                />
                              )}}
                            </Field>
                            <Typography.Text type="danger">
                              <ErrorMessage name={`watchers.${i}.role`} />
                            </Typography.Text>
                          </Form.Item>
                        </Col>
                        <Col span={8}>
                          <Form.Item label="Name">
                            <Field name={`watchers.${i}.name`}>
                              {({ field }: FieldProps) => (
                                <Input
                                  {...field}
                                  placeholder="Enter Name"
                                  readOnly={isPCD}
                                />
                              )}
                            </Field>
                            <Typography.Text type="danger">
                              <ErrorMessage name={`watchers.${i}.name`} />
                            </Typography.Text>
                          </Form.Item>
                        </Col>
                        <Col span={8}>
                          <Form.Item label="Email Address">
                            <Field name={`watchers.${i}.emailAddress`}>
                              {({ field }: FieldProps) => (
                                <Input
                                  {...field}
                                  placeholder="Enter Email"
                                  readOnly={isPCD}
                                />
                              )}
                            </Field>
                            <Typography.Text type="danger">
                              <ErrorMessage name={`watchers.${i}.emailAddress`} />
                            </Typography.Text>
                          </Form.Item>
                        </Col>
                      </Row>
                    );
                  })}
                  <div style={{ marginTop: 24, textAlign: "right" }}>
                    <Button
                      onClick={handleWatcherCancel}
                      style={{ marginRight: 8 }}
                    >
                      Cancel
                    </Button>
                    <Button
                      loading={isLoading}
                      type="primary"
                      onClick={() => props.handleSubmit()}
                      disabled={!props.isValid}
                    >
                      Save
                    </Button>
                  </div>
                </Form>
              );
            }}
          </Formik>
        </Spin>
      </Modal>
      <Modal
        width={1000}
        open={openAirportSectretariatModal}
        maskClosable={false}
        closable={false}
        title="Edit APC Secretariat"
        onCancel={handleAirportSectretariatCancel}
        okText="Save"
        footer={null}
      >
        <Spin spinning={loadingApproverList}>
          <Formik
            enableReinitialize
            initialValues={{
              airportAPC: airportAPC,
            }}
            onSubmit={handleApproversEditSubmit}
            validationSchema={airportAPCValidationSchema}
          >
            {(props) => {
              const apcSecretariatOnly = airportManagerList.filter(
                (item: any) => item.designation === "APC SECRETARIAT"
              );
              return (
                <>
                  <Form layout="vertical">
                    {props?.values?.airportAPC.map((airportAPC: any, i: any) => {
                      return (
                        <Row
                          gutter={16}
                          key={i}
                        >
                          {/* Designation */}
                          <Col span={8}>
                            <Form.Item label="Designation">
                              <Field name={`airportAPC.${i}.designation`}>
                                {({ field }: FieldProps) => (
                                  <Input
                                    {...field}
                                    placeholder="Enter designation"
                                    disabled
                                  />
                                )}
                              </Field>
                              <Typography.Text type="danger">
                                <ErrorMessage name={`airportAPC.${i}.designation`} />
                              </Typography.Text>
                            </Form.Item>
                          </Col>

                          {/* Name */}
                          <Col span={8}>
                            <Form.Item label="Name">
                              <Field name={`airportAPC.${i}.name`}>
                                {({ field }: FieldProps) => (
                                  <Select
                                    showSearch
                                    placeholder="Select name"
                                    value={airportAPC.name}
                                    disabled={airportAPC?.status === "completed"}
                                    onChange={(value) => {
                                      const selectedUser = apcSecretariatOnly.find(
                                        (item: any) => item.userName === value
                                      );

                                      if (selectedUser) {
                                        props.setFieldValue(`airportAPC.${i}.name`, selectedUser.userName);
                                        props.setFieldValue(`airportAPC.${i}.emailAddress`, selectedUser.userEmail);
                                        props.setFieldValue(`airportAPC.${i}.designation`, selectedUser.designation);
                                      }
                                    }}
                                  >
                                    {apcSecretariatOnly.map((item: any) => (
                                      <Select.Option
                                        key={item.uniqueId}
                                        value={item.userName}
                                      >
                                        {item.userName}
                                      </Select.Option>
                                    ))}
                                  </Select>
                                )}
                              </Field>
                              <Typography.Text type="danger">
                                <ErrorMessage name={`airportAPC.${i}.name`} />
                              </Typography.Text>
                            </Form.Item>
                          </Col>

                          {/* Email */}
                          <Col span={8}>
                            <Form.Item label="Email Address">
                              <Field name={`airportAPC.${i}.emailAddress`}>
                                {({ field }: FieldProps) => (
                                  <Select
                                    showSearch
                                    placeholder="Select email"
                                    value={airportAPC.emailAddress}
                                    disabled={airportAPC?.status === "completed"}
                                    onChange={(value) => {
                                      const selectedUser = apcSecretariatOnly.find(
                                        (item: any) => item.emailAddress === value
                                      );

                                      if (selectedUser) {
                                        props.setFieldValue(`airportAPC.${i}.emailAddress`, selectedUser.userEmail);
                                        props.setFieldValue(`airportAPC.${i}.name`, selectedUser.userName);
                                        props.setFieldValue(`airportAPC.${i}.designation`, selectedUser.designation);
                                      }
                                    }}
                                  >
                                    {apcSecretariatOnly.map((item: any) => (
                                      <Select.Option
                                        key={item.uniqueId}
                                        value={item.userEmail}
                                      >
                                        {item.userEmail}
                                      </Select.Option>
                                    ))}
                                  </Select>
                                )}
                              </Field>
                              <Typography.Text type="danger">
                                <ErrorMessage name={`airportAPC.${i}.emailAddress`} />
                              </Typography.Text>
                            </Form.Item>
                          </Col>
                        </Row>
                      );
                    })}
                    <div style={{ marginTop: 24, textAlign: "right" }}>
                      <Button
                        onClick={handleAirportSectretariatCancel}
                        style={{ marginRight: 8 }}
                      >
                        Cancel
                      </Button>
                      <Button
                        loading={isLoading}
                        type="primary"
                        onClick={() => props.handleSubmit()}
                        disabled={!props.isValid}
                      >
                        Save
                      </Button>
                    </div>
                  </Form>
                </>
              );
            }}
          </Formik>
        </Spin>
      </Modal>
      <Modal
        width={1000}
        open={openApcMemberModal}
        maskClosable={false}
        closable={false}
        title="Edit APC Members"
        onCancel={handleApcMemberCancel}
        okText="Save"
        footer={null}
      >
        <Spin spinning={loadingApproverList}>
          <Formik
            enableReinitialize
            initialValues={{
              airportAPCMember: airportAPCMember,
            }}
            onSubmit={handleApproversEditSubmit}
            validationSchema={airportAPCMemberValidationSchema}
          >
            {(props) => {
              const apcMemberOnly = airportManagerList.filter((item: any) => item.designation === "APC MEMBER");
              return (
                <>
                  <Form layout="vertical">
                    {props?.values?.airportAPCMember.map((airportAPCMember: any, i: any) => {
                      return (
                        <Row
                          gutter={16}
                          key={i}
                        >
                          {/* Designation */}
                          <Col span={8}>
                            <Form.Item label="Designation">
                              <Field name={`airportAPCMember.${i}.designation`}>
                                {({ field }: FieldProps) => (
                                  <Input
                                    {...field}
                                    placeholder="Enter designation"
                                    disabled
                                  />
                                )}
                              </Field>
                              <Typography.Text type="danger">
                                <ErrorMessage name={`airportAPCMember.${i}.designation`} />
                              </Typography.Text>
                            </Form.Item>
                          </Col>

                          {/* Name */}
                          <Col span={8}>
                            <Form.Item label="Name">
                              <Field name={`airportAPCMember.${i}.name`}>
                                {({ field }: FieldProps) => (
                                  <Select
                                    showSearch
                                    placeholder="Select name"
                                    value={airportAPCMember.name}
                                    disabled={airportAPCMember?.status === "completed"}
                                    onChange={(value) => {
                                      const selectedUser = apcMemberOnly.find((item: any) => item.userName === value);

                                      if (selectedUser) {
                                        props.setFieldValue(`airportAPCMember.${i}.name`, selectedUser.userName);
                                        props.setFieldValue(
                                          `airportAPCMember.${i}.emailAddress`,
                                          selectedUser.userEmail
                                        );
                                        props.setFieldValue(
                                          `airportAPCMember.${i}.designation`,
                                          selectedUser.designation
                                        );
                                      }
                                    }}
                                  >
                                    {apcMemberOnly.map((item: any) => (
                                      <Select.Option
                                        key={item.uniqueId}
                                        value={item.userName}
                                      >
                                        {item.userName}
                                      </Select.Option>
                                    ))}
                                  </Select>
                                )}
                              </Field>
                              <Typography.Text type="danger">
                                <ErrorMessage name={`airportAPCMember.${i}.name`} />
                              </Typography.Text>
                            </Form.Item>
                          </Col>

                          {/* Email */}
                          <Col span={8}>
                            <Form.Item label="Email Address">
                              <Field name={`airportAPCMember.${i}.emailAddress`}>
                                {({ field }: FieldProps) => (
                                  <Select
                                    showSearch
                                    placeholder="Select email"
                                    value={airportAPCMember.emailAddress}
                                    disabled={airportAPCMember?.status === "completed"}
                                    onChange={(value) => {
                                      const selectedUser = apcMemberOnly.find((item: any) => item.userEmail === value);

                                      if (selectedUser) {
                                        props.setFieldValue(
                                          `airportAPCMember.${i}.emailAddress`,
                                          selectedUser.userEmail
                                        );
                                        props.setFieldValue(`airportAPCMember.${i}.name`, selectedUser.userName);
                                        props.setFieldValue(
                                          `airportAPCMember.${i}.designation`,
                                          selectedUser.designation
                                        );
                                      }
                                    }}
                                  >
                                    {apcMemberOnly.map((item: any) => (
                                      <Select.Option
                                        key={item.uniqueId}
                                        value={item.userEmail}
                                      >
                                        {item.userEmail}
                                      </Select.Option>
                                    ))}
                                  </Select>
                                )}
                              </Field>
                              <Typography.Text type="danger">
                                <ErrorMessage name={`airportAPCMember.${i}.emailAddress`} />
                              </Typography.Text>
                            </Form.Item>
                          </Col>
                        </Row>
                      );
                    })}
                    <div style={{ marginTop: 24, textAlign: "right" }}>
                      <Button
                        onClick={handleApcMemberCancel}
                        style={{ marginRight: 8 }}
                      >
                        Cancel
                      </Button>
                      <Button
                        loading={isLoading}
                        type="primary"
                        onClick={() => props.handleSubmit()}
                        disabled={!props.isValid}
                      >
                        Save
                      </Button>
                    </div>
                  </Form>
                </>
              );
            }}
          </Formik>
        </Spin>
      </Modal>
    </>
  );
};
